var _clipPath, _clipPath2, _clipPath3, _g, _g2, _g3, _g4, _g5, _image, _image2, _image3, _image4, _image5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2500 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.085,0,0,4.085,30.9726,30.9824)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.504,
    y: -8.503,
    width: 612.284,
    height: 205.927,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-240.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 232.025,
    width: 612.284,
    height: 205.927,
    style: {
      fill: "rgb(145,210,229)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,72.4206,105.227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.719L-2.488,4.632C0.116,-1.804 -1.234,-9.415 -6.417,-14.573L-9.735,-17.876C-12.86,-20.917 -17.369,-22.06 -21.565,-20.875L-27.759,-19.125C-31.333,-18.116 -34.096,-15.277 -35.009,-11.678L-35.928,-8.051C-36.945,-4.041 -36.44,0.132 -34.628,3.714L-34.933,5.335L-34.211,9.166L-32.133,12.534L-28.949,15.035L-25.043,16.365L-23.772,16.365L-23.119,20.067L-20.766,24.143L-17.16,27.169L-12.736,28.779L-8.029,28.779L-3.606,27.169L0,24.143L2.353,20.067L3.171,15.431L2.353,10.796L0,6.719Z",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,70.4018,91.2684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,39.518L-4.423,41.128L-9.131,41.128L-13.554,39.518L-17.16,36.492L-19.513,32.416L-20.166,28.714L-21.437,28.714L-25.343,27.383L-28.527,24.883L-30.605,21.514L-31.327,17.684L-31.022,16.063C-32.834,12.48 -33.339,8.307 -32.322,4.298L-31.403,0.671C-31.037,-0.771 -30.374,-2.091 -29.481,-3.22C-31.183,-1.832 -32.432,0.082 -32.99,2.281L-33.909,5.908C-34.926,9.918 -34.421,14.09 -32.609,17.673L-32.914,19.294L-32.192,23.124L-30.114,26.493L-26.93,28.993L-23.024,30.324L-21.753,30.324L-21.101,34.026L-18.747,38.102L-15.141,41.128L-10.718,42.738L-6.011,42.738L-1.587,41.128L2.019,38.102L2.33,37.563L0,39.518Z",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,69.5218,61.5283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-15.101C-0.952,-16.027 -2.107,-16.674 -3.346,-17.012L-3.079,-17.53C-1.912,-19.79 -1.912,-22.474 -3.078,-24.734L-3.811,-26.153C-5.159,-28.765 -7.852,-30.406 -10.792,-30.406C-12.736,-30.406 -14.572,-29.688 -15.983,-28.446C-16.19,-28.564 -16.4,-28.677 -16.611,-28.786L-16.867,-29.282C-18.214,-31.894 -20.908,-33.535 -23.847,-33.535C-25.112,-33.535 -26.33,-33.23 -27.416,-32.676C-28.859,-34.861 -31.314,-36.2 -33.969,-36.2C-36.908,-36.2 -39.602,-34.559 -40.95,-31.947L-41.682,-30.528C-42.264,-29.4 -42.555,-28.167 -42.556,-26.933C-43.089,-27.046 -43.637,-27.106 -44.194,-27.106C-47.133,-27.106 -49.827,-25.465 -51.175,-22.853L-51.907,-21.433C-53.073,-19.173 -53.073,-16.489 -51.907,-14.229L-51.175,-12.81C-50.359,-11.228 -49.048,-10.003 -47.49,-9.282C-49.431,-7.327 -51.605,-4.115 -50.805,-1.209C-48.654,6.602 -43.436,8.055 -39.439,7.49C-38.97,8.092 -38.457,8.667 -37.901,9.208C-33.68,13.429 -27.507,15.039 -21.762,13.416L-19.133,12.674C-18.568,18.557 -8.868,21.099 -2.526,17.717C1.339,15.656 3.041,10.939 1.329,6.907C0.963,6.046 0.447,5.233 -0.263,4.525L-1.367,3.427L-0.927,3.502C1.273,3.88 3.508,3.066 4.95,1.361C8.854,-3.078 6.286,-8.845 2.096,-13.015L0,-15.101Z",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,71.8626,63.7447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.423L-0.44,-1.499L0.664,-0.4C0.893,-0.171 1.1,0.069 1.291,0.317C1.776,-0.006 2.222,-0.397 2.61,-0.855C2.864,-1.145 3.091,-1.44 3.292,-1.74C2.259,-1.35 1.125,-1.23 0,-1.423",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.6574,46.2348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.258L-2.63,26.001C-8.374,27.624 -14.548,26.014 -18.769,21.793C-19.325,21.252 -19.837,20.677 -20.307,20.075C-24.303,20.64 -29.522,19.187 -31.672,11.375C-32.472,8.47 -30.298,5.258 -28.357,3.302C-29.916,2.582 -31.226,1.357 -32.042,-0.225L-32.775,-1.644C-33.941,-3.904 -33.941,-6.589 -32.775,-8.849L-32.042,-10.268C-31.886,-10.57 -31.712,-10.859 -31.521,-11.134C-33.126,-10.42 -34.476,-9.176 -35.31,-7.559L-36.043,-6.14C-37.209,-3.88 -37.209,-1.195 -36.043,1.065L-35.31,2.484C-34.494,4.066 -33.184,5.29 -31.625,6.011C-33.566,7.967 -35.74,11.179 -34.94,14.084C-32.79,21.895 -27.571,23.349 -23.575,22.784C-23.106,23.386 -22.593,23.961 -22.037,24.502C-17.816,28.723 -11.643,30.333 -5.898,28.71L-3.268,27.967C-2.704,33.851 6.997,36.392 13.338,33.011C14.509,32.386 15.48,31.517 16.219,30.498C9.878,33.579 0.553,31.023 0,25.258",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,28.5958,26.1798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.534C0.557,5.534 1.106,5.593 1.638,5.707C1.639,4.473 1.93,3.239 2.512,2.112L3.245,0.692C3.4,0.39 3.575,0.102 3.765,-0.173C2.161,0.54 0.811,1.785 -0.024,3.401L-0.756,4.821C-0.89,5.079 -1.006,5.344 -1.109,5.613C-0.745,5.561 -0.374,5.534 0,5.534",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,124.384,103.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.662L-0.232,1.414C0.831,-1.094 0.385,-4.031 -1.46,-6.117C-2.671,-7.487 -4.27,-8.27 -5.925,-8.476C-5.551,-10.581 -6.131,-12.799 -7.609,-14.47C-9.653,-16.782 -12.798,-17.423 -15.458,-16.441L-15.503,-16.672C-15.996,-19.511 -18.371,-21.751 -21.285,-22.127L-22.726,-22.312C-24.192,-22.501 -25.658,-22.196 -26.88,-21.448L-29.126,-20.073C-30.686,-19.117 -31.708,-17.526 -31.933,-15.718C-34.809,-16.968 -38.336,-16.232 -40.422,-13.569L-41.329,-12.412C-43.145,-10.093 -43.29,-7.042 -42.015,-4.637C-42.951,-4.18 -43.804,-3.507 -44.498,-2.622L-45.404,-1.465C-48.046,1.907 -47.154,6.828 -43.497,9.057L-43.35,9.147C-43.134,9.278 -42.913,9.397 -42.689,9.504C-43.17,12.291 -41.969,15.247 -39.363,16.836L-39.217,16.925C-37.866,17.749 -36.351,18.07 -34.888,17.945C-34.405,19.578 -33.34,21.05 -31.754,22.017L-31.608,22.106C-28.234,24.163 -23.831,23.096 -21.774,19.722L-21.74,19.667C-21.216,20.357 -20.556,20.965 -19.766,21.447L-19.619,21.536C-16.245,23.593 -11.842,22.525 -9.785,19.151L-9.026,17.905C-8.392,16.866 -8.051,15.713 -7.991,14.554C-4.997,15.366 -1.707,14.154 -0.011,11.373L0.749,10.126C2.383,7.446 2.079,4.014 0,1.662",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,82.5259,93.9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.813C-0.39,1.077 -0.647,0.281 -0.764,-0.536C-1.012,0.414 -1.056,1.396 -0.911,2.349C-0.618,2.147 -0.314,1.967 0,1.813",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,124.644,102.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.432C-0.087,-1.097 -0.199,-0.766 -0.336,-0.443L-0.104,-0.195L-0.103,-0.195L0.061,0C0.089,-0.479 0.068,-0.958 0,-1.432",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,125.29,121.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-10.696L-0.76,-9.45C-2.456,-6.668 -5.746,-5.456 -8.74,-6.269C-8.8,-5.11 -9.141,-3.957 -9.775,-2.917L-10.534,-1.671C-12.591,1.703 -16.994,2.771 -20.368,0.713L-20.515,0.624C-21.305,0.142 -21.965,-0.465 -22.49,-1.156L-22.523,-1.101C-24.58,2.273 -28.983,3.341 -32.357,1.284L-32.503,1.195C-34.089,0.228 -35.154,-1.245 -35.637,-2.877C-37.101,-2.752 -38.615,-3.074 -39.966,-3.897L-40.112,-3.986C-42.718,-5.575 -43.919,-8.531 -43.438,-11.319C-43.662,-11.425 -43.883,-11.544 -44.099,-11.676L-44.246,-11.765C-46.156,-12.93 -47.31,-14.83 -47.602,-16.859C-48.37,-13.909 -47.192,-10.643 -44.403,-8.943L-44.256,-8.854C-44.04,-8.722 -43.819,-8.603 -43.595,-8.497C-44.076,-5.709 -42.875,-2.753 -40.269,-1.164L-40.123,-1.075C-38.772,-0.252 -37.258,0.07 -35.794,-0.055C-35.311,1.578 -34.246,3.05 -32.66,4.017L-32.514,4.106C-29.14,6.163 -24.737,5.096 -22.68,1.722L-22.647,1.667C-22.122,2.357 -21.462,2.965 -20.672,3.446L-20.525,3.536C-17.151,5.593 -12.748,4.525 -10.691,1.151L-9.932,-0.095C-9.298,-1.135 -8.957,-2.287 -8.897,-3.446C-5.903,-2.634 -2.613,-3.846 -0.917,-6.628L-0.157,-7.874C0.732,-9.331 1.046,-11.011 0.815,-12.618C0.641,-11.953 0.371,-11.305 0,-10.696",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,82.0825,-23.3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,67.986C0.354,68.331 0.723,68.656 1.102,68.965C-0.091,70.014 -0.829,71.425 -0.829,72.992L-0.829,73.134C-0.829,76.39 2.374,79.03 6.326,79.03L7.785,79.03C9.813,79.03 11.686,78.326 13.009,77.162C13.964,78.504 15.495,79.367 17.192,79.441L20.112,79.57C21.099,79.614 22.061,79.385 22.905,78.934C23.893,81.702 26.537,83.684 29.644,83.684L31.104,83.684C34.243,83.684 37.016,81.638 37.941,78.638C38.495,76.842 38.305,75.019 37.571,73.471C38.081,73.098 38.531,72.636 38.891,72.093L39.04,71.868C39.33,71.431 39.682,71.038 40.085,70.702C41.978,69.122 42.569,66.465 41.524,64.232L41.007,63.128C40.481,62.005 39.587,61.096 38.473,60.552L36.426,59.552C36.115,59.4 35.794,59.282 35.466,59.193C35.708,58.761 35.908,58.299 36.058,57.812C37.376,53.54 34.497,49.119 30.057,48.596L28.597,48.425C28.208,48.379 27.824,48.366 27.446,48.382C26.815,47.376 26.075,46.419 25.225,45.532C26.599,44.64 27.664,43.283 28.171,41.638C28.493,40.594 28.563,39.542 28.423,38.539C29.281,38.122 30.03,37.482 30.576,36.66L30.725,36.435C31.015,35.998 31.367,35.605 31.77,35.269C33.663,33.689 34.254,31.032 33.209,28.798L32.692,27.695C32.166,26.572 31.272,25.662 30.157,25.118L28.111,24.118C27.8,23.966 27.477,23.848 27.149,23.759C27.363,20.083 24.689,16.701 20.84,16.248L19.38,16.076C19.13,16.047 18.881,16.031 18.635,16.028C19.804,14.453 20.052,12.329 19.192,10.492L18.676,9.388C18.15,8.265 17.256,7.356 16.141,6.811L14.338,5.931C14.686,5.329 14.923,4.657 15.019,3.94L15.408,1.044C15.662,-0.843 14.908,-2.725 13.422,-3.916L13.211,-4.084C12.802,-4.412 12.442,-4.798 12.143,-5.23C11.438,-6.247 10.433,-6.962 9.314,-7.315C8.776,-7.755 8.168,-8.122 7.5,-8.395C6.216,-8.921 4.882,-9.045 3.625,-8.836C3.238,-11.259 1.619,-13.365 -0.728,-14.327C-4.075,-15.698 -7.764,-14.34 -9.537,-11.455C-10.202,-12.133 -11.009,-12.686 -11.929,-13.062C-16.066,-14.757 -20.727,-12.284 -21.644,-7.909L-21.945,-6.47C-22.018,-6.121 -22.062,-5.774 -22.083,-5.429C-23.443,-6.221 -25.118,-6.406 -26.671,-5.843L-27.816,-5.427C-28.981,-5.003 -29.967,-4.194 -30.609,-3.132L-31.189,-2.172C-34.561,-2.307 -37.737,-0.018 -38.476,3.512L-38.624,4.219C-39.39,3.149 -40.452,2.285 -41.731,1.761C-45.869,0.066 -50.529,2.539 -51.446,6.914L-51.748,8.353C-51.962,9.376 -51.945,10.388 -51.738,11.341C-55.667,10.221 -59.827,12.651 -60.688,16.759L-60.99,18.197C-61.611,21.162 -60.302,24.039 -57.974,25.606C-59.608,26.588 -60.858,28.219 -61.288,30.269L-61.589,31.707C-62.468,35.899 -59.491,39.919 -55.226,40.301L-55.055,40.317C-53.219,40.481 -51.483,39.937 -50.117,38.91C-49.887,39.086 -49.654,39.256 -49.416,39.418C-49.278,39.882 -49.097,40.336 -48.871,40.774L-48.139,42.193C-46.791,44.805 -44.097,46.446 -41.158,46.446C-39.334,46.446 -37.605,45.814 -36.234,44.71C-36.063,45.512 -35.768,46.294 -35.346,47.025C-33.931,49.477 -31.315,50.987 -28.484,50.987C-25.653,50.987 -23.037,49.477 -21.621,47.025C-20.205,44.573 -20.205,41.552 -21.621,39.1C-21.986,38.468 -22.431,37.899 -22.939,37.402C-22.743,37.421 -22.547,37.434 -22.348,37.434C-20.291,37.434 -18.381,36.398 -17.255,34.695L-13.992,35.883L-14.383,38.102L-13.566,42.737L-11.212,46.814L-7.606,49.84L-4.399,51.007L-4.587,51.748C-6.068,57.591 -4.32,63.781 0,67.986",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,60.4614,15.5271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.485C-1.415,6.937 -4.031,8.447 -6.862,8.447C-9.694,8.447 -12.31,6.937 -13.725,4.485C-14.147,3.754 -14.442,2.972 -14.613,2.171C-15.984,3.274 -17.713,3.906 -19.537,3.906C-22.476,3.906 -25.17,2.265 -26.518,-0.347L-27.25,-1.766C-27.476,-2.204 -27.657,-2.658 -27.795,-3.121C-28.033,-3.284 -28.266,-3.454 -28.496,-3.63C-29.862,-2.603 -31.598,-2.058 -33.434,-2.223L-33.605,-2.239C-36.73,-2.519 -39.162,-4.753 -39.893,-7.576L-39.968,-7.219C-40.846,-3.027 -37.87,0.993 -33.605,1.375L-33.434,1.391C-31.598,1.555 -29.862,1.011 -28.496,-0.016C-28.266,0.16 -28.033,0.33 -27.795,0.493C-27.657,0.956 -27.476,1.41 -27.25,1.848L-26.518,3.267C-25.17,5.879 -22.476,7.52 -19.537,7.52C-17.713,7.52 -15.984,6.888 -14.613,5.784C-14.442,6.586 -14.147,7.368 -13.725,8.099C-12.31,10.551 -9.694,12.061 -6.862,12.061C-4.031,12.061 -1.415,10.551 0,8.099C1.022,6.33 1.306,4.264 0.853,2.33C0.678,3.076 0.394,3.803 0,4.485",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,113.852,18.2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-9.973C-0.403,-9.637 -0.755,-9.244 -1.045,-8.807L-1.194,-8.582C-1.74,-7.76 -2.489,-7.119 -3.347,-6.702C-3.207,-5.7 -3.277,-4.648 -3.599,-3.604C-4.106,-1.959 -5.17,-0.601 -6.545,0.29C-5.918,0.945 -5.351,1.638 -4.843,2.36C-4.296,1.675 -3.868,0.884 -3.599,0.01C-3.277,-1.034 -3.207,-2.086 -3.347,-3.088C-2.489,-3.505 -1.74,-4.146 -1.194,-4.968L-1.045,-5.193C-0.755,-5.63 -0.403,-6.023 0,-6.359C1.755,-7.824 2.39,-10.213 1.641,-12.333C1.324,-11.436 0.77,-10.615 0,-9.973",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.782978,-0.62205,-0.62205,-0.782978,24.4994,-2.74094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.136,-0.801C-1.664,0.862 -1.567,2.677 -0.858,4.277L-1.136,4.046C-2.704,2.744 -3.562,0.932 -3.699,-0.929C-2.853,-0.731 -1.984,-0.691 -1.136,-0.801",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.983464,0.181104,0.181104,0.983464,118.015,32.2157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.38,-1.37C-0.144,-0.919 0.136,-0.5 0.452,-0.119C0.163,0.019 -0.116,0.185 -0.38,0.375C-0.526,-0.304 -0.572,-0.989 -0.521,-1.661C-0.476,-1.564 -0.43,-1.467 -0.38,-1.37Z",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,122.167,47.1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.424C-0.403,-3.088 -0.755,-2.695 -1.045,-2.258L-1.194,-2.033C-1.554,-1.49 -2.004,-1.028 -2.515,-0.655C-2.074,0.273 -1.831,1.3 -1.825,2.36C-1.594,2.123 -1.382,1.863 -1.194,1.581L-1.045,1.356C-0.755,0.919 -0.403,0.526 0,0.19C1.755,-1.275 2.39,-3.664 1.641,-5.784C1.324,-4.887 0.77,-4.066 0,-3.424",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.024,56.5178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.892C-0.926,-1.892 -3.698,0.154 -6.837,0.154L-8.297,0.154C-11.404,0.154 -14.048,-1.828 -15.036,-4.596C-15.881,-4.146 -16.842,-3.917 -17.829,-3.96L-20.749,-4.089C-22.446,-4.164 -23.977,-5.027 -24.932,-6.369C-26.255,-5.205 -28.128,-4.501 -30.156,-4.501L-31.615,-4.501C-34.833,-4.501 -37.555,-6.252 -38.454,-8.66C-38.659,-8.113 -38.77,-7.53 -38.77,-6.924L-38.77,-6.783C-38.77,-3.527 -35.567,-0.887 -31.615,-0.887L-30.156,-0.887C-28.128,-0.887 -26.255,-1.591 -24.932,-2.755C-23.977,-1.413 -22.446,-0.55 -20.749,-0.475L-17.829,-0.347C-16.842,-0.303 -15.881,-0.532 -15.036,-0.982C-14.048,1.786 -11.404,3.768 -8.297,3.768L-6.837,3.768C-3.698,3.768 -0.926,1.721 0,-1.278C0.411,-2.611 0.412,-3.957 0.086,-5.195C0.059,-5.094 0.031,-4.993 0,-4.892",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,77.4957,15.5365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.199L0.188,8.458L-3.019,7.29L-6.625,4.265L-8.979,0.188L-9.478,-2.641L-9.796,-0.834L-8.979,3.802L-6.625,7.879L-3.019,10.904L-0.449,11.84C-0.37,10.957 -0.222,10.074 0,9.199",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,67.6995,10.447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.642L0.391,-1.577L-2.872,-2.764C-3.998,-1.061 -5.908,-0.025 -7.965,-0.025C-8.164,-0.025 -8.36,-0.038 -8.556,-0.057C-8.048,0.44 -7.603,1.009 -7.238,1.641C-6.913,2.204 -6.663,2.797 -6.488,3.406C-5.018,3.039 -3.722,2.135 -2.872,0.849L0.236,1.981L0,0.642Z",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.879056,-0.476718,-0.476718,-0.879056,84.952,39.8212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.57,-1.031C-2.756,-0.579 -2.924,-0.117 -3.072,0.356C-4.258,4.165 -4.039,8.201 -2.57,11.781C-5.368,7.729 -6.272,2.622 -4.977,-2.187C-4.298,-1.627 -3.473,-1.237 -2.57,-1.031",
    style: {
      fill: "rgb(137,170,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,113.686,133.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-87.812C-0.219,-87.893 -0.463,-87.781 -0.543,-87.562L-4.256,-77.512L-7.073,-87.53C-7.136,-87.755 -7.37,-87.886 -7.595,-87.822C-7.82,-87.759 -7.951,-87.525 -7.888,-87.301L-3.599,-72.052L-9.552,-60.084L-9.573,-60.033L-14.63,-45.3L-29.113,-25.074L-27.947,-39.767L-18.409,-67.54C-18.378,-67.629 -18.358,-67.721 -18.348,-67.814L-15.822,-90.826L-13.035,-100.022C-12.832,-100.693 -13.211,-101.402 -13.882,-101.605C-14.553,-101.808 -15.262,-101.429 -15.465,-100.759L-18.286,-91.45L-18.333,-91.221L-20.856,-68.231L-30.4,-40.44C-30.435,-40.339 -30.457,-40.234 -30.465,-40.128L-31.855,-22.612L-33.403,-19.621L-31.6,-78.843L-28.579,-99.717L-23.746,-103.636C-23.449,-103.877 -23.276,-104.239 -23.276,-104.622L-23.276,-121.141L-19.703,-126.17C-19.297,-126.741 -19.431,-127.534 -20.002,-127.94C-20.574,-128.346 -21.366,-128.212 -21.772,-127.64L-23.911,-124.63L-23.911,-130.854C-23.911,-131.205 -24.195,-131.489 -24.546,-131.489C-24.896,-131.489 -25.18,-131.205 -25.18,-130.854L-25.18,-122.844L-25.58,-122.281C-25.733,-122.066 -25.815,-121.809 -25.815,-121.546L-25.815,-105.227L-30.563,-101.376C-30.811,-101.175 -30.975,-100.888 -31.02,-100.572L-33.879,-80.821L-37.812,-94.276L-42.88,-128.628L-42.88,-136.213C-42.88,-136.447 -43.07,-136.637 -43.303,-136.637C-43.537,-136.637 -43.727,-136.447 -43.727,-136.213L-43.727,-128.597L-43.722,-128.536L-39.182,-97.765L-51.143,-113.9L-51.363,-114.053L-55.751,-115.354L-54.998,-119.208C-54.953,-119.437 -55.103,-119.66 -55.332,-119.704C-55.561,-119.749 -55.783,-119.6 -55.828,-119.37L-56.481,-116.029L-59.335,-119.555C-59.482,-119.737 -59.748,-119.765 -59.93,-119.618C-60.111,-119.471 -60.139,-119.205 -59.992,-119.023L-56.569,-114.792L-56.549,-114.771L-56.533,-114.754L-56.482,-114.712L-56.475,-114.707L-56.41,-114.672L-56.388,-114.663L-56.36,-114.652L-51.739,-113.282L-38.92,-95.991L-38.645,-94.123L-38.632,-94.066L-34.144,-78.712L-36.043,-16.305L-52.845,-47.842L-54.24,-57.885C-54.253,-57.978 -54.286,-58.067 -54.337,-58.145L-55.561,-60.017L-53.968,-66.964C-53.889,-67.306 -54.103,-67.646 -54.444,-67.725C-54.786,-67.803 -55.126,-67.59 -55.205,-67.248L-56.525,-61.491L-59.132,-65.479C-59.324,-65.772 -59.717,-65.855 -60.011,-65.663C-60.304,-65.471 -60.387,-65.078 -60.195,-64.784L-55.477,-57.569L-54.087,-47.556L-54.018,-47.345L-37.098,-15.585L-37.098,12.252L-45.447,0.137L-49.096,-16.372L-49.2,-16.57L-55.792,-23.609C-55.506,-25.601 -54.748,-31.133 -55.009,-31.973C-55.077,-32.194 -55.309,-32.313 -55.531,-32.248C-55.753,-32.182 -55.88,-31.945 -55.817,-31.723C-55.687,-31.257 -56.064,-27.783 -56.535,-24.402L-62.458,-30.726C-62.617,-30.896 -62.885,-30.905 -63.056,-30.746C-63.226,-30.586 -63.235,-30.318 -63.075,-30.148L-49.897,-16.076L-46.255,0.4L-46.19,0.549L-37.098,13.743L-37.098,48.825L-32.585,48.825L-32.585,9.049L-20.769,0.368L-20.618,0.159L-15.317,-15.97L-11.54,-17.639C-11.327,-17.733 -11.23,-17.983 -11.324,-18.197C-11.419,-18.41 -11.669,-18.507 -11.882,-18.413L-15.831,-16.668C-15.941,-16.62 -16.025,-16.527 -16.062,-16.413L-21.379,-0.234L-32.585,7.998L-32.585,-15.677L-29.483,-21.674C-29.405,-21.824 -29.358,-21.988 -29.345,-22.156L-29.243,-23.439L-13.906,-44.858L-13.85,-44.967L-8.782,-59.732L-2.769,-71.821C-2.722,-71.915 -2.712,-72.023 -2.74,-72.124L-3.866,-76.126L0.25,-87.269C0.331,-87.488 0.219,-87.731 0,-87.812",
    style: {
      fill: "rgb(109,77,68)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,74.3695,25.1808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.455L-1.395,0L0,9.455Z",
    style: {
      fill: "rgb(127,149,153)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.145945,-0.989293,-0.989293,0.145945,79.0707,10.5014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.463,8.173L6.995,8.173L7.056,8.17L6.995,8.173L-9.463,8.173Z",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,72.9744,21.0555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.125L-0.609,0L-0.609,0.001L0,4.125Z",
    style: {
      fill: "rgb(121,126,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,74.9736,-3.3262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.777L-0.604,37.962L-1.999,28.507L-2.608,24.382L-5.01,8.101L-5.015,8.039L-5.015,0.423C-5.015,0.189 -4.825,0 -4.591,0L-4.424,0.034C-4.498,0.111 -4.544,0.214 -4.544,0.329L-4.544,7.945L-4.54,8.007L0,38.777Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.2748,31.6503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,33.408L-0.443,33.408L2.078,10.439L2.125,10.21L4.946,0.901C5.111,0.355 5.611,0.003 6.153,0C5.811,0.139 5.532,0.426 5.416,0.807L2.595,10.116L2.548,10.345L0.025,33.335L0,33.408Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,79.9715,43.5472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.803L1.129,0L0,7.803Z",
    style: {
      fill: "rgb(127,149,153)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,81.1008,32.7383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.809L0,10.807L0,10.809M0.451,7.695L1.565,0L0.451,7.695Z",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,81.1011,40.4325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.113L0.451,0L0,3.113Z",
    style: {
      fill: "rgb(121,126,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,80.2768,1.8208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,50.574L-0.305,49.529L0.824,41.726L0.824,41.725L1.275,38.612L2.389,30.917C2.434,30.601 2.597,30.314 2.845,30.113L7.594,26.263L7.594,9.943C7.594,9.68 7.676,9.423 7.828,9.208L8.228,8.645L8.228,0.635C8.228,0.285 8.513,0 8.863,0L8.983,0.013C8.812,0.126 8.699,0.32 8.699,0.541L8.699,8.551L8.299,9.114C8.146,9.329 8.064,9.586 8.064,9.849L8.064,26.169L3.315,30.019C3.067,30.22 2.904,30.507 2.859,30.823L0,50.574Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,109.712,45.7488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.286L3.43,0L0,9.286Z",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,109.9,45.4718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.232L-0.188,9.563L3.242,0.277C3.305,0.106 3.467,0 3.639,0C3.687,0 3.737,0.008 3.785,0.026L3.805,0.036L3.712,0.183L0,10.232Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,108.62,45.4723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.586L-0.423,19.586L1.467,15.786L-2.822,0.537C-2.833,0.499 -2.838,0.46 -2.838,0.421C-2.837,0.237 -2.716,0.068 -2.529,0.015C-2.492,0.005 -2.455,0 -2.418,0C-2.359,0 -2.301,0.013 -2.248,0.036C-2.349,0.141 -2.394,0.293 -2.352,0.443L1.937,15.692L0,19.586Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,90.2446,5.6702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.348L1.668,0L0,2.348Z",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,90.2446,5.1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.449L0,2.881L1.668,0.533C1.914,0.188 2.3,0.004 2.694,0C2.478,0.088 2.283,0.235 2.139,0.439L0,3.449Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.6747,67.6343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.013C0.007,0.009 0.013,0.004 0.02,0C0.013,0.004 0.007,0.009 0,0.013",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.6813,67.5448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.39L-4.191,0.981C-4.261,0.873 -4.294,0.752 -4.294,0.632C-4.293,0.426 -4.192,0.224 -4.007,0.102C-4,0.098 -3.993,0.094 -3.986,0.09C-3.885,0.029 -3.773,0 -3.661,0C-3.621,0 -3.58,0.004 -3.54,0.011C-3.83,0.204 -3.911,0.595 -3.72,0.887L0.403,7.193L0,7.39Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.756,13.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.017C0.006,0.012 0.012,0.007 0.019,0.003C0.012,0.007 0.006,0.012 0,0.017M0.021,0.001C0.022,0.001 0.022,0 0.022,0C0.022,0 0.022,0.001 0.021,0.001",
    style: {
      fill: "rgb(121,134,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,79.6904,13.5993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,51.459L-0.467,51.459L-0.149,40.998L-4.637,25.645L-4.649,25.588L-4.925,23.72L-17.744,6.428L-18.171,6.302L-19.03,6.047L-22.365,5.058L-22.393,5.048L-22.415,5.039L-22.48,5.004L-22.487,4.999L-22.537,4.957L-22.554,4.94L-22.573,4.919L-25.997,0.688C-26.06,0.61 -26.091,0.516 -26.092,0.423C-26.092,0.299 -26.038,0.177 -25.934,0.093C-25.928,0.088 -25.922,0.083 -25.916,0.079C-25.915,0.078 -25.914,0.077 -25.913,0.076L-25.912,0.076C-25.839,0.025 -25.755,0 -25.672,0C-25.613,0 -25.555,0.012 -25.501,0.035C-25.648,0.186 -25.663,0.426 -25.527,0.594L-22.103,4.825L-22.084,4.846L-22.067,4.863L-22.017,4.905L-22.01,4.91L-21.945,4.945L-21.923,4.954L-21.895,4.964L-17.274,6.334L-4.455,23.626L-4.179,25.494L-4.167,25.551L0.321,40.904L0,51.459Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.6746,13.5979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.589L-0.364,3.139L0.183,0.342C0.222,0.14 0.399,0 0.597,0C0.624,0 0.652,0.002 0.679,0.008L0.765,0.035L0.653,0.248L0,3.589Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.6308,65.5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.154L-0.332,5.646L0.85,0.491C0.917,0.198 1.178,0 1.467,0C1.507,0 1.548,0.004 1.588,0.012C1.457,0.098 1.358,0.232 1.32,0.397L0,6.154Z",
    style: {
      fill: "rgb(97,67,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,180.468,15.1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-30.613C0,-30.613 -10.055,-22.856 -5.476,-15.175C-0.897,-7.494 2.634,-1.277 12.758,0.899C22.882,3.075 39.637,2.4 47.773,6.371C55.91,10.341 56.982,13.211 79.235,11.776C101.488,10.341 104.218,5.417 117.385,2.594C130.552,-0.228 130.013,2.978 144.484,-3.248C158.956,-9.475 169.061,-7.546 161.696,-20.731C154.332,-33.916 130.748,-43.824 130.748,-43.824L0,-30.613Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,487.487,12.5876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-28.686C0,-28.686 2.244,-5.999 14.944,-1.82C27.643,2.36 35.072,4.571 43.908,2.805C52.744,1.039 59.7,-3.098 66.791,-4.002C73.881,-4.906 86.342,0.867 84.736,-13.249C83.129,-27.365 66.791,-33.257 66.791,-33.257L0,-28.686Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.085,0,0,4.085,30.9726,30.9824)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.504,
    y: -8.504,
    width: 612.283,
    height: 437.953,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,614.212,195.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.003C0,0.377 -0.003,0.757 -0.009,1.134C-0.015,1.516 -0.025,1.896 -0.036,2.271C-0.372,12.683 -2.992,20.789 -6.175,20.789L-628.369,20.789C-630.074,20.789 -631.617,18.459 -632.735,14.698C-633.704,11.441 -634.351,7.104 -634.508,2.271C-634.519,1.896 -634.529,1.516 -634.535,1.134C-634.54,0.757 -634.544,0.377 -634.544,-0.003C-634.544,-11.484 -631.779,-20.792 -628.369,-20.792L-6.175,-20.792C-4.47,-20.792 -2.927,-18.463 -1.808,-14.702C-0.69,-10.943 0,-5.744 0,-0.003",
    style: {
      fill: "rgb(113,111,110)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,341.576,65.058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,111.104L-317.32,111.104L-317.32,26.215L-263.688,0L0,0L0,111.104Z",
    style: {
      fill: "rgb(243,158,196)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,205.546,-191.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.573,
    y: 281.835,
    width: 60.904,
    height: 56.853,
    style: {
      fill: "rgb(234,238,248)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,205.544,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.483,
    y: 284.814,
    width: 53.082,
    height: 53.874,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,205.545,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.227,
    y: 289.284,
    width: 45.595,
    height: 44.934,
    style: {
      fill: "rgb(145,210,229)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,190.085,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.128,
    y: 288.4,
    width: 6.333,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,223.984,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.078,
    y: 288.4,
    width: 6.332,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-201.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.227,
    y: 314.848,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-187.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.227,
    y: 307.957,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,171.926,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.703,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,240.653,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.066,
    y: 315.655,
    width: 1.025,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,206.57,-167.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.025,
    y: 289.394,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-177.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.296,
    y: 254.419,
    width: 100.486,
    height: 98.461,
    style: {
      fill: "rgb(243,158,196)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1016.07,-191.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.836,
    y: 281.835,
    width: 60.904,
    height: 56.853,
    style: {
      fill: "rgb(234,238,248)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1016.07,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.747,
    y: 284.814,
    width: 53.082,
    height: 53.874,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1016.07,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.491,
    y: 289.284,
    width: 45.595,
    height: 44.934,
    style: {
      fill: "rgb(145,210,229)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1000.61,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.392,
    y: 288.4,
    width: 6.333,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1034.51,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.341,
    y: 288.4,
    width: 6.333,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-201.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.49,
    y: 314.848,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-187.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.49,
    y: 307.957,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,982.454,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.967,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1051.18,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.33,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1017.1,-167.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.288,
    y: 289.394,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-168.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.08,
    y: 244.627,
    width: 113.334,
    height: 108.253,
    style: {
      fill: "rgb(243,158,196)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.538,-191.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.069,
    y: 281.835,
    width: 60.904,
    height: 56.853,
    style: {
      fill: "rgb(234,238,248)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.538,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.98,
    y: 284.814,
    width: 53.082,
    height: 53.874,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.539,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.724,
    y: 289.284,
    width: 45.595,
    height: 44.934,
    style: {
      fill: "rgb(145,210,229)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,591.08,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.626,
    y: 288.4,
    width: 6.332,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,624.978,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.575,
    y: 288.4,
    width: 6.332,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-201.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.723,
    y: 314.848,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-187.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.723,
    y: 307.957,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,572.92,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.2,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,641.647,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.563,
    y: 315.655,
    width: 1.025,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,607.564,-167.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.522,
    y: 289.394,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,404.084,-191.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.842,
    y: 281.835,
    width: 60.904,
    height: 56.853,
    style: {
      fill: "rgb(234,238,248)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,404.082,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.752,
    y: 284.814,
    width: 53.082,
    height: 53.874,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,404.083,-194.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.496,
    y: 289.284,
    width: 45.595,
    height: 44.934,
    style: {
      fill: "rgb(145,210,229)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,388.623,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.397,
    y: 288.4,
    width: 6.333,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,422.521,-193.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.346,
    y: 288.4,
    width: 6.333,
    height: 45.818,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-201.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.496,
    y: 314.848,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-187.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.496,
    y: 307.957,
    width: 45.596,
    height: 0.807,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,370.466,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.973,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,439.192,-220.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.336,
    y: 315.655,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,405.108,-167.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.294,
    y: 289.394,
    width: 1.024,
    height: 18.563,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,687.334,-220.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.376,
    y: 323.695,
    width: 15.086,
    height: 2.514,
    style: {
      fill: "rgb(251,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,687.334,-138.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.866,
    y: 244.627,
    width: 12.106,
    height: 79.068,
    style: {
      fill: "rgb(109,91,84)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,928.194,-220.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.806,
    y: 323.695,
    width: 15.086,
    height: 2.514,
    style: {
      fill: "rgb(251,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,525.892,-220.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.655,
    y: 323.695,
    width: 15.086,
    height: 2.514,
    style: {
      fill: "rgb(255,235,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,525.892,-141.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.145,
    y: 247.239,
    width: 12.106,
    height: 76.456,
    style: {
      fill: "rgb(109,91,84)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,525.891,-249.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.262,
    y: 326.209,
    width: 9.871,
    height: 26.671,
    style: {
      fill: "rgb(255,235,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,468.68,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.965,2.359L-3.71,2.359L0.375,0L-5.964,0C-6.34,0.74 -6.34,1.619 -5.965,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.865977,0.500083,0.500083,-0.865977,468.271,51.5266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.214,2.17L3.503,2.17L-11.634,-6.572L-12.813,-4.529L-1.214,2.17Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,579.419,50.3747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,36.475L-124.509,36.475L-124.509,0L-32.78,0L-24.12,9.637L-23.282,10.568L-18.854,15.496L-18.018,16.427L-13.728,21.201L-12.891,22.132L-8.033,27.537L-7.196,28.468L-2.546,33.642L-1.709,34.573L0,36.475Z",
    style: {
      fill: "rgb(79,110,124)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,463.65,54.4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.48,0.931L0,0.931L0,0L-86.644,0L-87.48,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,463.649,60.012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-92.487,0.931L0,0.931L0,0L-91.65,0L-92.487,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,463.65,65.8706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-97.751,0.931L0,0.931L0,0L-96.915,0L-97.751,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,463.649,71.5755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-102.879,0.931L0,0.931L0,0L-102.042,0L-102.879,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,463.65,77.9117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-108.573,0.931L0,0.931L0,0L-107.736,0L-108.573,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,464.618,84.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-113.441,0.931L0,0.931L0,0L-112.5,0L-113.441,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,546.638,50.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.311L0,-0.001C0,0.565 -0.458,1.024 -1.024,1.024L-71.994,1.024C-71.618,0.283 -71.618,-0.596 -71.995,-1.335L-1.024,-1.335C-0.458,-1.335 0,-0.877 0,-0.311",
    style: {
      fill: "rgb(47,75,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,582.399,91.3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.887L0,-0.186C0,0.816 -0.813,1.63 -1.816,1.63L-117.618,1.63L-117.618,-4.517L-1.63,-4.517C-0.73,-4.517 0,-3.787 0,-2.887",
    style: {
      fill: "rgb(251,248,251)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,582.399,92.9964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.446L0,-1.816C0,-0.813 -0.813,0 -1.816,0L-117.618,0L-117.618,-3.446L0,-3.446Z",
    style: {
      fill: "rgb(225,221,224)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.782,336.453L542.74,336.453L542.74,332.974L562.782,332.974L562.782,336.453ZM481.836,336.453L473.285,336.453L473.285,332.974L481.836,332.974L481.836,336.453Z",
    style: {
      fill: "rgb(231,137,156)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.74,336.453L538.829,336.453L538.829,332.974L542.74,332.974L542.74,336.453ZM485.747,336.453L481.836,336.453L481.836,332.974L485.747,332.974L485.747,336.453Z",
    style: {
      fill: "rgb(222,209,197)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,530.325,92.9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.479L-3.743,3.479L-3.743,2.235L-49.339,2.235L-49.339,3.479L-53.082,3.479L-53.082,0L0,0L0,3.479Z",
    style: {
      fill: "rgb(33,46,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,526.582,95.2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.244L-4.731,1.244L-4.731,0L-5.756,0L-5.756,1.244L-10.412,1.244L-10.412,0L-16.745,0L-16.745,1.244L-27.361,1.244L-27.361,0L-33.693,0L-33.693,1.244L-39.095,1.244L-39.095,0L-40.119,0L-40.119,1.244L-45.595,1.244L-45.595,0L0,0L0,1.244Z",
    style: {
      fill: "rgb(142,186,182)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1000.61,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.392,
    y: 332.974,
    width: 6.333,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1034.51,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.341,
    y: 332.974,
    width: 6.333,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,982.454,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.967,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1051.18,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.33,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,520.978,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.899,2.359L0.258,2.359C-0.117,1.619 -0.117,0.74 0.259,0L-0.899,0C-1.158,0.764 -1.158,1.595 -0.899,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,530.301,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,2.359L0.258,2.359C-0.118,1.619 -0.118,0.74 0.259,0L-0.9,0C-1.159,0.764 -1.159,1.595 -0.9,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,539.382,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.899,2.359L0.259,2.359C-0.117,1.619 -0.117,0.74 0.259,0L-0.899,0C-1.158,0.764 -1.158,1.595 -0.899,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,493.366,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.899,2.359L0.259,2.359C-0.117,1.619 -0.117,0.74 0.259,0L-0.899,0C-1.158,0.764 -1.158,1.595 -0.899,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,502.689,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,2.359L0.258,2.359C-0.118,1.619 -0.118,0.74 0.259,0L-0.9,0C-1.159,0.764 -1.159,1.595 -0.9,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,511.77,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.899,2.359L0.259,2.359C-0.117,1.619 -0.117,0.74 0.259,0L-0.899,0C-1.158,0.764 -1.158,1.595 -0.899,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,474.902,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,2.359L0.258,2.359C-0.118,1.619 -0.118,0.74 0.259,0L-0.9,0C-1.159,0.764 -1.159,1.595 -0.9,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,483.982,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,2.359L0.258,2.359C-0.118,1.619 -0.118,0.74 0.259,0L-0.9,0C-1.159,0.764 -1.159,1.595 -0.9,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,807.764,-67.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.972,
    y: 244.627,
    width: 108.324,
    height: 7.455,
    style: {
      fill: "rgb(251,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,807.764,-84.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.972,
    y: 253.287,
    width: 108.324,
    height: 7.455,
    style: {
      fill: "rgb(251,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,807.764,-75.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.972,
    y: 252.081,
    width: 108.324,
    height: 1.206,
    style: {
      fill: "rgb(225,221,224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,807.764,-93.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.972,
    y: 260.741,
    width: 108.324,
    height: 1.206,
    style: {
      fill: "rgb(225,221,224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,817.635,-173.533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.533,
    y: 261.947,
    width: 41.073,
    height: 79.088,
    style: {
      fill: "rgb(48,27,17)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,817.636,-172.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.352,
    y: 261.947,
    width: 39.436,
    height: 78.222,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,817.822,-172.114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.795,
    y: 264.467,
    width: 36.736,
    height: 72.629,
    style: {
      fill: "rgb(167,112,68)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,817.821,-172.114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.137,
    y: 264.467,
    width: 4.051,
    height: 72.629,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,797.427,-193.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.794,
    y: 310.75,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,838.215,-193.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.188,
    y: 310.75,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,797.427,-154.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.794,
    y: 290.821,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,838.215,-154.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.188,
    y: 290.821,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,797.427,-114.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.794,
    y: 271.123,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,838.215,-114.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.188,
    y: 271.123,
    width: 16.343,
    height: 1.863,
    style: {
      fill: "rgb(126,74,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,417.947,126.309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65,-1.65C0.738,-1.65 -0.001,-0.911 -0.001,0.001C-0.001,0.912 0.738,1.65 1.65,1.65C2.561,1.65 3.3,0.912 3.3,0.001C3.3,-0.911 2.561,-1.65 1.65,-1.65",
    style: {
      fill: "rgb(250,199,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,417.947,127.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.851,-0.851C0.381,-0.851 -0.001,-0.47 -0.001,0.001C-0.001,0.471 0.381,0.851 0.851,0.851C1.321,0.851 1.704,0.471 1.704,0.001C1.704,-0.47 1.321,-0.851 0.851,-0.851",
    style: {
      fill: "rgb(247,200,134)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.613,-78.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.251,
    y: 247.239,
    width: 68.615,
    height: 13.503,
    style: {
      fill: "rgb(251,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.613,-90.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.251,
    y: 259.345,
    width: 68.615,
    height: 1.396,
    style: {
      fill: "rgb(225,221,224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,543.864,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.02,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,556.344,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.26,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,566.866,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.521,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,581.674,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.925,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,591.732,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.954,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.538,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.357,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,616.596,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.386,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,630.938,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.557,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,640.994,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.585,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,656.082,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.129,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,666.138,-116.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.157,
    y: 260.741,
    width: 2.328,
    height: 24.725,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.613,-140.179)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.251,
    y: 284.161,
    width: 68.615,
    height: 1.306,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.613,-125.651)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.251,
    y: 276.897,
    width: 68.615,
    height: 1.306,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,606.613,-132.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.251,
    y: 280.529,
    width: 68.615,
    height: 1.306,
    style: {
      fill: "rgb(31,50,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,464.781,25.271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,60.495L-130.301,60.495L-130.301,40.044L-59.368,0L0,35.196L0,60.495Z",
    style: {
      fill: "rgb(243,158,196)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,687.335,-241.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.984,
    y: 326.209,
    width: 9.871,
    height: 18.757,
    style: {
      fill: "rgb(255,235,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,928.195,-241.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.414,
    y: 326.209,
    width: 9.871,
    height: 18.757,
    style: {
      fill: "rgb(255,235,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,807.763,-256.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.854,
    y: 342.599,
    width: 110.559,
    height: 1.084,
    style: {
      fill: "rgb(231,137,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,344.351,84.482)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -110.559,
    y: 0,
    width: 110.559,
    height: 1.284,
    style: {
      fill: "rgb(231,137,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,344.351,84.4827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.871,
    y: 0,
    width: 9.871,
    height: 2.367,
    style: {
      fill: "rgb(241,208,168)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,464.781,84.4827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.871,
    y: 0,
    width: 9.871,
    height: 2.367,
    style: {
      fill: "rgb(241,208,168)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,264.708,181.723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.242L-1.109,0.488L-12.067,0.488L-12.103,0.053L-13.176,-13.242C-13.198,-13.505 -12.99,-13.73 -12.727,-13.73L-0.45,-13.73C-0.186,-13.73 0.021,-13.505 0,-13.242",
    style: {
      fill: "rgb(187,202,204)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,255.714,160.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.623L-0.007,-1.604C-0.034,-1.542 -0.135,-1.337 -0.372,-1.241C-0.372,-1.241 -0.359,-0.683 -1.118,0.255C-1.909,1.404 -3.539,1.264 -4.175,0.286C-4.175,0.286 -4.513,-0.253 -4.917,0.056C-5.031,0.143 -5.17,0.188 -5.31,0.16C-5.463,0.131 -5.664,0.004 -5.724,-0.22C-5.768,-0.377 -5.741,-0.584 -5.576,-0.839C-5.576,-0.839 -5.53,-1.887 -4.563,-1.572C-4.563,-1.572 -4.439,-2.616 -3.29,-2.336C-3.29,-2.336 -2.701,-3.027 -2.095,-2.399C-2.095,-2.399 -1.806,-2.764 -0.813,-2.081C-0.813,-2.081 0.104,-2.456 0,-1.623",
    style: {
      fill: "rgb(235,72,80)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,255.706,160.478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.872C-0.026,-1.81 -0.128,-1.605 -0.365,-1.509C-0.365,-1.509 -0.352,-0.951 -1.11,-0.012C-1.902,1.136 -3.531,0.996 -4.167,0.018C-4.167,0.018 -4.505,-0.521 -4.91,-0.212C-5.023,-0.125 -5.163,-0.079 -5.303,-0.107C-5.455,-0.137 -5.656,-0.264 -5.717,-0.487C-5.695,-0.587 -5.415,-0.856 -5.336,-0.978C-5.336,-0.978 -5.522,-1.867 -4.556,-1.554C-4.556,-1.554 -4.432,-2.597 -3.283,-2.317C-3.283,-2.317 -2.693,-3.008 -2.088,-2.38C-2.088,-2.38 -1.798,-2.745 -0.806,-2.062C-0.806,-2.062 -0.19,-2.457 0,-1.872",
    style: {
      fill: "rgb(238,121,130)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,262.395,157.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.88L-0.017,1.891C-0.073,1.928 -0.272,2.041 -0.522,1.987C-0.522,1.987 -0.824,2.457 -1.978,2.809C-3.277,3.317 -4.549,2.288 -4.528,1.122C-4.528,1.122 -4.505,0.486 -5.013,0.515C-5.156,0.523 -5.297,0.483 -5.397,0.381C-5.507,0.271 -5.603,0.053 -5.528,-0.166C-5.476,-0.32 -5.337,-0.477 -5.058,-0.596C-5.058,-0.596 -4.432,-1.437 -3.808,-0.635C-3.808,-0.635 -3.12,-1.43 -2.325,-0.555C-2.325,-0.555 -1.45,-0.797 -1.301,0.063C-1.301,0.063 -0.856,-0.077 -0.417,1.045C-0.417,1.045 0.553,1.248 0,1.88",
    style: {
      fill: "rgb(235,72,80)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,262.378,157.708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.665C-0.057,1.702 -0.255,1.815 -0.506,1.761C-0.506,1.761 -0.808,2.231 -1.962,2.583C-3.261,3.091 -4.532,2.062 -4.511,0.895C-4.511,0.895 -4.489,0.259 -4.997,0.289C-5.139,0.297 -5.281,0.256 -5.381,0.155C-5.49,0.045 -5.586,-0.173 -5.511,-0.392C-5.437,-0.462 -5.054,-0.528 -4.92,-0.585C-4.92,-0.585 -4.576,-1.426 -3.952,-0.624C-3.952,-0.624 -3.265,-1.419 -2.469,-0.543C-2.469,-0.543 -1.594,-0.785 -1.445,0.075C-1.445,0.075 -1,-0.065 -0.561,1.056C-0.561,1.056 0.17,1.074 0,1.665",
    style: {
      fill: "rgb(238,121,130)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.87552,0.483181,0.483181,0.87552,258.737,166.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.332,-7.492C2.332,-7.492 1.225,-1.917 2.563,0.251L2.332,0.379C2.332,0.379 0.746,-1.545 2.01,-7.176L2.332,-7.492Z",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,255.946,167.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.748,-8.156C-2.748,-8.156 0.372,-4.974 -2.422,0L-2.748,0C-2.748,0 0.139,-4.291 -3.12,-7.923L-2.748,-8.156Z",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.9,158.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.309L-0.018,3.317C-0.081,3.343 -0.298,3.416 -0.533,3.315C-0.533,3.315 -0.919,3.719 -2.119,3.846C-3.49,4.098 -4.543,2.847 -4.301,1.705C-4.301,1.705 -4.159,1.085 -4.663,1.018C-4.805,0.999 -4.936,0.932 -5.015,0.814C-5.102,0.684 -5.154,0.453 -5.039,0.252C-4.959,0.11 -4.793,-0.017 -4.496,-0.081C-4.496,-0.081 -3.722,-0.789 -3.262,0.117C-3.262,0.117 -2.436,-0.533 -1.821,0.477C-1.821,0.477 -0.916,0.406 -0.932,1.279C-0.932,1.279 -0.469,1.225 -0.251,2.41C-0.251,2.41 0.663,2.794 0,3.309",
    style: {
      fill: "rgb(235,72,80)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.881,158.479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.122C-0.063,3.148 -0.279,3.221 -0.515,3.121C-0.515,3.121 -0.9,3.524 -2.1,3.651C-3.472,3.903 -4.525,2.652 -4.283,1.511C-4.283,1.511 -4.141,0.89 -4.645,0.823C-4.786,0.804 -4.918,0.737 -4.996,0.619C-5.083,0.49 -5.136,0.258 -5.021,0.057C-4.934,0.002 -4.546,0.01 -4.404,-0.021C-4.404,-0.021 -3.907,-0.781 -3.446,0.125C-3.446,0.125 -2.62,-0.525 -2.006,0.485C-2.006,0.485 -1.1,0.414 -1.117,1.286C-1.117,1.286 -0.654,1.233 -0.435,2.418C-0.435,2.418 0.279,2.574 0,3.122",
    style: {
      fill: "rgb(238,121,130)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.956076,-0.293118,-0.293118,0.956076,260.441,167.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.781,-7.084C-2.781,-7.084 0.851,-4.724 -2.456,-0.076L-2.781,-0.11C-2.781,-0.11 0.568,-4.628 -3.176,-6.892L-2.781,-7.084Z",
    style: {
      fill: "rgb(138,181,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,251.562,162.282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.532C0,4.532 2.91,3.911 3.779,5.712L10.608,5.712C10.608,5.712 13.402,2.359 16.475,4.222C16.475,4.222 16.289,1.397 11.726,2.794C11.726,2.794 11.633,0.31 14.271,0.714C14.271,0.714 10.795,-1.18 9.553,1.676C9.553,1.676 9.398,-0.466 10.05,-0.745C10.05,-0.745 7.535,-0.59 7.318,2.018C7.318,2.018 6.387,-1.087 3.966,-0.931C3.966,-0.931 5.549,0.465 5.331,2.049C5.331,2.049 3.593,-0.9 1.482,0.31C1.482,0.31 3.717,1.273 3.5,2.576C3.5,2.576 1.172,0.248 -0.877,2.7C-0.877,2.7 2.32,2.235 2.662,3.663C2.662,3.663 0.815,3.29 0,4.532",
    style: {
      fill: "rgb(74,174,75)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,265.709,165.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.576C0,-1.576 -3.29,-0.179 -3.539,2.18L-10.058,2.18C-10.058,2.18 -10.803,0.721 -12.665,1.497C-12.665,1.497 -12.696,-0.303 -10.585,-0.086C-10.585,-0.086 -12.665,-0.924 -13.286,-0.459C-13.286,-0.459 -12.199,-1.793 -10.368,-0.831C-10.368,-0.831 -11.144,-2.104 -12.106,-2.29C-12.106,-2.29 -9.468,-2.631 -8.474,-1.297C-8.474,-1.297 -8.474,-3.19 -7.388,-3.594C-7.388,-3.594 -7.109,-1.669 -6.348,-1.514C-6.348,-1.514 -5.586,-3.756 -3.849,-3.594C-3.849,-3.594 -4.625,-1.855 -3.973,-1.483C-3.973,-1.483 -1.956,-3.656 -1.242,-2.259C-1.242,-2.259 -2.763,-1.855 -2.825,-0.893C-2.825,-0.893 -1.086,-2.818 0,-1.576",
    style: {
      fill: "rgb(115,184,69)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,252.604,179.926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.835L-0.149,0L-0.148,0L0,1.835Z",
    style: {
      fill: "rgb(151,154,155)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,263.599,167.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.218L-10.958,14.218L-10.995,13.769L-11.143,11.933L-1.463,11.023L-0.444,0L0.659,0C0.911,0 1.111,0.205 1.111,0.452C1.111,0.464 1.11,0.476 1.109,0.488L0,14.218Z",
    style: {
      fill: "rgb(174,190,192)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.829,168.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.87L-6.435,-13.818L-12.887,-13.864C-15.003,-12.734 -12.872,-11.234 -12.872,-11.234L-12.4,-11.234C-12.331,-9.673 -11.937,-2.625 -10.311,-0.887C-9.557,-0.082 -6.491,-0.167 -6.491,-0.167C-6.491,-0.167 -3.288,0 -2.626,-0.882C-1.176,-2.813 -0.648,-9.673 -0.544,-11.234L-0.03,-11.234C-0.03,-11.234 2.116,-12.74 0,-13.87",
    style: {
      fill: "rgb(133,93,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.902,162.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.442L-0.263,-0.311L-0.313,-0.264L-0.345,-0.203L-0.349,-0.131L-0.327,-0.064L-0.22,0.019L-0.172,0.025L-0.081,0L0.182,-0.131L0.232,-0.177L0.265,-0.239L0.268,-0.31L0.246,-0.377L0.139,-0.46L0.091,-0.467L0,-0.442Z",
    style: {
      fill: "rgb(133,93,70)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.28,136.368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.861C-0.11,12.271 1.755,5.579 5.265,0C2.333,5.917 0.554,12.28 0,18.861",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.942,143.431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.59C0.895,1.83 5.553,1.217 8.631,0C5.717,1.709 1.363,2.081 0,5.59",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.572,137.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.696C0.076,4.316 0.007,3.925 -0.061,3.548C-0.138,3.123 -0.263,2.711 -0.42,2.309C-0.724,1.533 -1.151,0.821 -1.675,0.174C-1.817,0 -2.07,0.25 -1.924,0.423C-1.412,1.031 -1.001,1.726 -0.708,2.464C-0.568,2.819 -0.455,3.185 -0.36,3.554C-0.262,3.932 -0.226,4.327 -0.098,4.696L0,4.696Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.515,149.339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.992C0.781,0.808 3.99,0 5.71,1.557C3.644,0.721 1.424,1.276 0,2.992",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.83,143.605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.006C-1.369,2.942 -4.48,1.824 -7.553,1.289L-7.56,1.205C-4.373,0 -0.534,3.068 0,6.006",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445,144.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.418C0,1.418 -0.829,0.654 -0.044,0C0.209,0.209 0.496,0.32 0,1.418",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.351,146.296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.357C0,-1.357 -1.001,-0.838 -0.415,0C-0.117,-0.136 0.19,-0.167 0,-1.357",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.952,145.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.616C0,-0.616 -1.2,-1.154 -1.229,0.093C-0.884,0.27 -0.598,0.538 0,-0.616",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.423,143.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.294C0,1.294 0.236,0 -0.982,0.27C-1.071,0.647 -1.263,0.989 0,1.294",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.591,143.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.387C0,1.387 -0.954,0.786 -0.299,0C-0.013,0.16 0.29,0.218 0,1.387",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.112,144.037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.996C0,1.996 -0.761,0.505 0.67,0C0.914,0.421 1.257,0.724 0,1.996",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.502,145.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.928C0,1.928 -0.624,0.375 0.847,0C1.052,0.441 1.366,0.774 0,1.928",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.305,146.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.442C0,1.442 -0.382,0.194 0.786,0C0.916,0.357 1.138,0.636 0,1.442",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.62,152.472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.83C0,-1.83 -0.769,0 2.075,-0.05C1.63,-0.899 1.478,-1.63 0,-1.83",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.414,148.928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.377C0,1.377 -0.507,0 1.26,0.152C0.997,0.758 0.914,1.29 0,1.377",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.794,149.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.899C0,1.899 -1.131,0.542 0.933,0C0.88,0.794 1.002,1.43 0,1.899",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.445,149.366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.175C0,1.175 -0.327,0 1.402,0.25C1.065,0.734 0.916,1.167 0,1.175",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.659,151.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.534C0,-1.534 -0.894,-0.675 0.748,0C0.703,-0.597 0.797,-1.053 0,-1.534",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.532,153.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.596C0,-2.596 -1.551,-0.674 1.264,0C1.196,-1.098 1.365,-1.984 0,-2.596",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.894,147.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.95C0,-1.95 -0.423,0.132 1.96,-0.105C1.76,-1.007 1.688,-2.082 0,-1.95",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.044,147.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.348C0,-1.348 -0.037,0.343 1.797,-0.181C1.513,-0.859 1.304,-1.691 0,-1.348",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.717,144.049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.37C0,2.37 -1.365,1.264 0.667,0C0.951,0.707 1.422,1.452 0,2.37",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.611,149.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.284C0,-1.284 -0.059,0.472 2.228,-0.235C1.879,-0.913 1.625,-1.756 0,-1.284",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.457,140.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.071C0,-0.071 1.469,1.463 2.633,-0.63C1.778,-0.98 0.854,-1.534 0,-0.071",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.925,143.173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.869C0,-0.869 0.85,1.078 2.664,-0.486C1.982,-1.109 1.306,-1.947 0,-0.869",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.54,143.128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.66C0,2.66 0.844,0.112 -1.171,0C-1.222,1.17 -1.419,2.536 0,2.66",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.623,149.755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.919C0,0.919 -0.679,-1.156 -2.937,0.521C-2.26,1.184 -1.619,2.075 0,0.919",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.345,153.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.298C0,0.298 -1.606,-1.221 -2.527,0.532C-1.65,0.931 -0.684,1.519 0,0.298",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.447,151.472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.14C0,1.14 -0.639,-0.673 -2.048,0.317C-1.528,0.974 -1.014,1.813 0,1.14",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.131,140.965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.005C0,-0.005 -0.592,-0.724 -1.897,-0.066C-0.952,0.416 -0.324,0.719 0,-0.005",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.583,142.316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.007C0,-0.007 -0.778,-0.951 -2.493,-0.087C-1.251,0.546 -0.426,0.944 0,-0.007",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.651,139.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.29C0,-0.29 -0.979,-1.025 -2.442,0.219C-1.086,0.542 -0.19,0.735 0,-0.29",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.091,138.223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.003C0,2.003 1.22,1.902 1.487,0C0.259,0.66 -0.539,1.111 0,2.003",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.2,142.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.826C0,1.826 -1.123,1.065 -0.22,0C0.207,0.246 0.832,0.805 0,1.826",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.306,143.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.821C0,1.821 -0.889,0.797 0.257,0C0.606,0.348 1.066,1.049 0,1.821",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.971,143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.789C0,1.789 -0.789,0.686 0.428,0C0.742,0.379 1.134,1.121 0,1.789",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,454.869,145.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.803C0,-0.803 1.273,-1.271 1.611,0.084C1.162,0.287 0.344,0.468 0,-0.803",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.383,147.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.449C0,-1.449 -0.35,0 -1.61,-0.487C-1.531,-0.913 -1.587,-1.317 0,-1.449",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.054,148.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.21C0,-1.21 -0.767,0.278 -2.012,-0.589C-1.813,-1.033 -1.766,-1.488 0,-1.21",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.001,149.384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.16C0,-1.16 -0.796,0.313 -2.024,-0.579C-1.816,-1.019 -1.761,-1.473 0,-1.16",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.22,136.104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.275C-1.319,17.145 -2.042,14.731 -2.466,12.282C-3.531,8.29 -4.311,4.125 -3.539,0L-3.479,0.004C-3.181,4.11 -3.17,8.218 -2.277,12.236C-1.578,14.571 -0.496,16.968 0,19.275",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.174,140.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.315C-0.038,7.521 0.714,6.023 1.86,4.684C3.021,3.327 4.329,2.098 5.479,0.732C5.738,0.423 5.321,-0.014 5.029,0.282C4.321,1.001 3.664,1.78 2.993,2.534C2.368,3.234 1.726,3.924 1.152,4.668C0.17,5.942 -0.752,7.7 -0.105,9.329L0,9.315Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.775,139.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.357C-0.101,2.969 -0.349,2.633 -0.587,2.316C-0.833,1.989 -1.11,1.689 -1.41,1.411C-2.014,0.85 -2.708,0.393 -3.455,0.046C-3.661,-0.049 -3.839,0.259 -3.633,0.35C-2.904,0.671 -2.232,1.109 -1.641,1.642C-1.354,1.9 -1.089,2.182 -0.837,2.475C-0.577,2.777 -0.368,3.125 -0.085,3.406L0,3.357Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.27,148.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.173C0.185,3.686 0.276,3.187 0.531,2.724C0.78,2.271 1.104,1.869 1.497,1.533C2.298,0.846 3.378,0.532 4.422,0.621C4.759,0.649 4.758,0.121 4.422,0.094C3.237,0 2.039,0.394 1.151,1.187C0.732,1.561 0.388,2.035 0.158,2.547C-0.062,3.035 -0.264,3.633 -0.163,4.173L0,4.173Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.295,147.701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.358C-1.338,1.539 -2.68,0.536 -4.296,0.495C-5.883,0.461 -7.405,0.807 -8.885,1.427L-8.903,1.396C-7.634,0.377 -5.872,0 -4.275,0.299C-2.75,0.597 -0.861,0.982 0,2.358",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,433.011,146.758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.255C0,1.255 -1.08,0.932 -0.661,0C-0.342,0.077 -0.035,0.051 0,1.255",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.407,150.119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.401C0,-1.401 -0.673,-0.496 0.221,0C0.431,-0.252 0.692,-0.415 0,-1.401",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.964,149.555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.299C0,-1.299 -1.314,-1.256 -0.794,-0.123C-0.406,-0.116 -0.031,0 0,-1.299",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.45,147.655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.986C0,0.986 -0.355,-0.28 -1.332,0.496C-1.246,0.874 -1.269,1.266 0,0.986",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.558,147.071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.178C0,1.178 -1.121,1.056 -0.877,0.063C-0.55,0.081 -0.252,0 0,1.178",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,434.268,145.964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.088C0,2.088 -1.338,1.082 -0.273,0C0.131,0.271 0.572,0.394 0,2.088",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.084,146.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.104C0,2.104 -1.242,0.981 -0.084,0C0.294,0.307 0.722,0.468 0,2.104",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.264,147.553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.64C0,1.64 -0.89,0.685 0.074,0C0.347,0.263 0.669,0.417 0,1.64",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.34,151.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.514C0,-1.514 0.112,0.468 2.645,-0.824C1.873,-1.392 1.416,-1.982 0,-1.514",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.905,147.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.653C0,1.653 -1.059,0.637 0.595,0C0.625,0.66 0.784,1.174 0,1.653",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.737,148.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.116C0,2.116 -1.612,1.392 0.006,0C0.307,0.737 0.695,1.256 0,2.116",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.834,147.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.446C0,1.446 -0.809,0.533 0.855,0C0.764,0.582 0.82,1.037 0,1.446",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.088,150.316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.163C0,-1.163 -0.427,0 1.345,-0.112C1.043,-0.629 0.927,-1.081 0,-1.163",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.628,153.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.359C0,-2.359 -0.551,0.048 2.274,-0.58C1.732,-1.537 1.495,-2.407 0,-2.359",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.076,145.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.198C0,-1.198 0.532,0.859 2.571,-0.399C1.996,-1.123 1.459,-2.057 0,-1.198",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.831,146.814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.656C0,-0.656 0.708,0.88 2.127,-0.395C1.574,-0.88 1.022,-1.536 0,-0.656",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.576,143.957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.423C0,2.423 -1.712,2.027 -0.439,0C0.126,0.512 0.875,0.974 0,2.423",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.151,148.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.467C0,-0.467 0.717,1.137 2.462,-0.501C1.851,-0.957 1.254,-1.604 0,-0.467",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.801,140.099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.954C0,0.954 1.993,1.689 2.121,-0.703C1.199,-0.643 0.126,-0.735 0,0.954",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.958,142.426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.165C0,0.165 1.617,1.542 2.563,-0.659C1.676,-0.92 0.701,-1.377 0,0.165",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.241,144.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.15C0,2.15 -0.358,-0.51 -2.219,0.273C-1.752,1.347 -1.33,2.66 0,2.15",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.559,151.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.182C0,-0.182 -1.52,-1.749 -2.815,0.748C-1.915,1.047 -0.948,1.567 0,-0.182",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.74,154.913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.736C0,-0.736 -2.11,-1.397 -2.169,0.583C-1.206,0.557 -0.079,0.661 0,-0.736",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.25,152.641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.301C0,0.301 -1.369,-1.049 -2.202,0.459C-1.446,0.822 -0.616,1.35 0,0.301",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,435.656,142.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.409C0,-0.409 -0.847,-0.795 -1.732,0.368C-0.672,0.386 0.026,0.384 0,-0.409",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.653,143.282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.537C0,-0.537 -1.113,-1.045 -2.276,0.484C-0.882,0.508 0.034,0.505 0,-0.537",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,434.479,141.708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.296C0,-1.296 -1.202,-1.528 -1.972,0.232C-0.612,-0.072 0.278,-0.292 0,-1.296",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,435.298,138.636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.452C0,2.452 1.052,1.827 0.458,0C-0.356,1.131 -0.875,1.886 0,2.452",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.504,151.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.456C0.277,3.181 0.481,2.842 0.735,2.545C0.992,2.245 1.263,1.956 1.556,1.692C2.147,1.159 2.82,0.72 3.548,0.4C3.754,0.309 3.576,0 3.371,0.096C2.623,0.443 1.93,0.9 1.325,1.461C1.032,1.732 0.76,2.025 0.519,2.344C0.275,2.667 0.018,3.01 -0.085,3.407L0,3.456Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.538,154.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.409C0,-0.409 0.847,-0.795 1.732,0.368C0.672,0.386 -0.026,0.384 0,-0.409",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.541,155.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.537C0,-0.537 1.113,-1.045 2.276,0.484C0.882,0.508 -0.034,0.505 0,-0.537",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.37,152.865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.129C0,0.129 0.667,-0.897 2.468,-0.23C1.306,0.538 0.53,1.026 0,0.129",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.896,150.722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.452C0,2.452 -1.052,1.827 -0.458,0C0.356,1.131 0.875,1.886 0,2.452",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.467,152.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.984C1.038,0.377 2.314,-0.066 3.539,0.007C3.954,0.077 4.364,0.21 4.717,0.488L4.702,0.558C3.877,0.769 3.168,0.735 2.353,0.685C1.581,0.702 0.798,0.82 0.029,1.05L0,0.984Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.113,155.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.65C0,-1.65 0.912,-1.461 0.938,0C0.072,-0.611 -0.489,-1.026 0,-1.65",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.709,155.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.168C0,-2.168 1.198,-1.92 1.233,0C0.094,-0.803 -0.643,-1.348 0,-2.168",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.841,155.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.398C0,-2.398 1.106,-1.875 0.688,0C-0.229,-1.049 -0.818,-1.752 0,-2.398",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.781,151.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.188C0,2.188 -0.479,1.062 1.079,-0.061C1.068,1.333 1.04,2.249 0,2.188",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.42,140.211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.545C0,1.545 -1.342,1.354 -0.998,0C-0.506,0.035 0.3,0.263 0,1.545",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.601,143.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.75C0,1.75 -1.248,1.22 -0.567,0C-0.101,0.16 0.62,0.588 0,1.75",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.785,141.694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.795C0,1.795 -1.192,1.149 -0.4,0C0.049,0.203 0.726,0.697 0,1.795",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,441.488,142.893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.013C0,-0.013 0.939,-0.992 1.837,0.078C1.522,0.457 0.866,0.979 0,-0.013",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,433.429,149.565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.57C0,-1.57 0.321,-0.114 -1.026,0C-1.141,-0.417 -1.369,-0.756 0,-1.57",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,435.458,150.019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.674C0,-1.674 -0.037,0 -1.536,-0.234C-1.552,-0.72 -1.71,-1.15 0,-1.674",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.926,150.866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.673C0,-1.673 -0.07,0 -1.565,-0.263C-1.57,-0.75 -1.72,-1.183 0,-1.673",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,441.894,136.092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.575C-0.208,16.984 0.242,14.411 0.975,11.937C1.836,7.735 3.027,3.506 5.605,0L5.657,0.029C4.049,3.99 2.192,7.831 1.165,11.98C0.728,14.474 0.607,17.198 0,19.575",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.696,143.544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.666C0.979,1.878 5.621,1.299 8.73,0C5.733,1.624 1.287,2.048 0,5.666",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.441,137.651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.906C0.082,4.517 0.022,4.118 -0.038,3.73C-0.106,3.292 -0.219,2.865 -0.365,2.447C-0.648,1.64 -1.056,0.885 -1.569,0.202C-1.72,0 -2.003,0.213 -1.846,0.415C-1.34,1.063 -0.945,1.798 -0.667,2.57C-0.535,2.937 -0.432,3.314 -0.343,3.693C-0.25,4.095 -0.222,4.513 -0.098,4.906L0,4.906Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.19,149.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.307C0.594,0.896 4.147,0 5.769,1.91L5.742,1.95C3.779,0.621 1.196,1.496 0,3.307",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.689,144.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.379C0.001,4.646 -0.561,3.821 -0.97,3.248C-1.433,2.599 -1.99,2.026 -2.626,1.547C-4.039,0.482 -5.821,-0.054 -7.586,0.05C-7.897,0.068 -7.899,0.556 -7.586,0.537C-5.911,0.435 -4.253,0.898 -2.894,1.892C-2.266,2.351 -1.711,2.92 -1.254,3.55C-1.036,3.851 -0.836,4.169 -0.657,4.495C-0.488,4.804 -0.355,5.161 -0.13,5.433L0,5.379Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.819,143.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.479C0,1.479 -0.816,0.667 -0.018,0C0.231,0.223 0.516,0.344 0,1.479",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.179,146.239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.406C0,-1.406 -1.01,-0.884 -0.439,0C-0.138,-0.135 0.169,-0.163 0,-1.406",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.776,145.749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.608C0,-0.608 -1.19,-1.191 -1.242,0.108C-0.899,0.299 -0.618,0.583 0,-0.608",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.252,143.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.344C0,1.344 0.259,0 -0.964,0.258C-1.059,0.65 -1.257,1.003 0,1.344",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.417,143.491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.451C0,1.451 -0.943,0.807 -0.275,0C0.009,0.172 0.31,0.238 0,1.451",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.921,143.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.069C0,2.069 -0.734,0.501 0.706,0C0.942,0.444 1.279,0.766 0,2.069",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,441.287,145.423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.994C0,1.994 -0.596,0.363 0.881,0C1.078,0.464 1.386,0.817 0,1.994",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.072,147.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.488C0,1.488 -0.359,0.18 0.812,0C0.935,0.374 1.152,0.669 0,1.488",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.345,152.825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.894C0,-1.894 -0.801,-0.001 2.043,0C1.613,-0.893 1.474,-1.658 0,-1.894",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.145,149.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445C0,1.445 -0.482,0 1.281,0.191C1.008,0.819 0.916,1.371 0,1.445",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.514,149.285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.962C0,1.962 -1.107,0.527 0.967,0C0.9,0.827 1.01,1.492 0,1.962",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.171,149.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.222C0,1.222 -0.306,-0.009 1.419,0.284C1.073,0.782 0.916,1.231 0,1.222",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.387,152.382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.613C0,-1.613 -0.909,-0.735 0.721,0C0.687,-0.623 0.789,-1.097 0,-1.613",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.247,154.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.729C0,-2.729 -1.585,-0.755 1.218,0C1.169,-1.146 1.354,-2.066 0,-2.729",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.713,147.542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.056C0,-2.056 -0.46,0.106 1.927,-0.097C1.743,-1.041 1.69,-2.162 0,-2.056",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.846,147.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.429C0,-1.429 -0.067,0.333 1.776,-0.179C1.504,-0.891 1.31,-1.762 0,-1.429",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.518,144.073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.458C0,2.458 -1.345,1.28 0.709,0C0.98,0.743 1.438,1.527 0,2.458",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.389,149.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.367C0,-1.367 -0.09,0.462 2.208,-0.233C1.872,-0.945 1.633,-1.829 0,-1.367",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.357,140.861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.118C0,-0.118 1.442,1.509 2.643,-0.652C1.794,-1.033 0.88,-1.627 0,-0.118",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.799,143.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.945C0,-0.945 0.815,1.1 2.657,-0.496C1.986,-1.159 1.325,-2.045 0,-0.945",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.352,143.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.794C0,2.794 0.889,0.154 -1.124,0C-1.195,1.218 -1.416,2.638 0,2.794",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.348,149.927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1C0,1 -0.642,-1.175 -2.93,0.531C-2.264,1.234 -1.639,2.175 0,1",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.012,153.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.353C0,0.353 -1.579,-1.26 -2.531,0.55C-1.661,0.982 -0.705,1.613 0,0.353",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.138,151.725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.219C0,1.219 -0.606,-0.683 -2.033,0.323C-1.525,1.018 -1.026,1.902 0,1.219",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.029,140.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.012C0,0.012 -0.579,-0.748 -1.896,-0.087C-0.96,0.433 -0.337,0.76 0,0.012",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.457,142.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.015C0,0.015 -0.761,-0.984 -2.491,-0.115C-1.261,0.568 -0.443,0.999 0,0.015",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.58,139.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.28C0,-0.28 -0.965,-1.064 -2.451,0.205C-1.101,0.567 -0.208,0.784 0,-0.28",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.002,138.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.06C0,2.06 1.221,1.977 1.522,0C0.283,0.665 -0.523,1.12 0,2.06",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.044,142.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.907C0,1.907 -1.109,1.093 -0.187,0C0.235,0.264 0.85,0.859 0,1.907",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.122,143.711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.893C0,1.893 -0.871,0.809 0.29,0C0.632,0.369 1.08,1.108 0,1.893",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.8,143.036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.856C0,1.856 -0.769,0.692 0.46,0C0.767,0.401 1.146,1.18 0,1.856",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.702,145.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.867C0,-0.867 1.281,-1.331 1.595,0.087C1.143,0.29 0.321,0.464 0,-0.867",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.199,147.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.504C0,-1.504 -0.375,0 -1.627,-0.531C-1.54,-0.974 -1.589,-1.396 0,-1.504",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.848,148.093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.214C0,-1.214 -0.793,0.323 -2.023,-0.604C-1.816,-1.063 -1.761,-1.537 0,-1.214",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,441.77,149.522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.161C0,-1.161 -0.822,0.359 -2.034,-0.593C-1.818,-1.048 -1.755,-1.52 0,-1.161",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.875,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.935C2.108,15.457 3.095,7.765 3.109,0C3.756,7.726 2.728,15.671 0,22.935",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.715,140.475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.5C-0.108,9.024 -0.327,7.642 -0.768,6.253C-1.931,4.102 -3.791,2.381 -4.662,0.034L-4.612,0C-2.85,1.768 -1.618,3.914 -0.591,6.172C0.153,7.387 0.738,9.243 0,10.5",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.007,139.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.086C0.259,3.751 0.43,3.358 0.655,2.999C0.878,2.644 1.112,2.296 1.378,1.971C1.874,1.365 2.453,0.828 3.126,0.424C3.32,0.308 3.141,0 2.949,0.121C2.259,0.552 1.652,1.104 1.146,1.739C0.88,2.072 0.633,2.422 0.427,2.795C0.213,3.181 -0.02,3.595 -0.085,4.037L0,4.086Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.888,149.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.932C0.116,4.352 -0.048,3.686 -0.221,3.132C-0.396,2.57 -0.663,2.029 -1.022,1.562C-1.735,0.633 -2.845,0 -4.041,0.13C-4.375,0.166 -4.377,0.694 -4.041,0.656C-2.976,0.535 -2.003,1.09 -1.364,1.918C-1.039,2.338 -0.789,2.819 -0.602,3.314C-0.403,3.842 -0.343,4.402 -0.163,4.932L0,4.932Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.619,148.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.865C0.266,2.7 0.48,2.456 0.709,2.246C0.99,1.987 1.292,1.748 1.611,1.539C2.177,1.17 2.798,0.892 3.46,0.753C4.948,0.44 6.45,0.932 7.621,1.86C7.864,2.053 8.211,1.709 7.965,1.516C6.7,0.521 5.119,0 3.512,0.296C2.778,0.431 2.073,0.734 1.455,1.149C0.871,1.542 0.138,2.097 -0.112,2.779L0,2.865Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.238,147.718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.495C0,1.495 0.95,1.11 0.581,0C0.301,0.092 0.031,0.061 0,1.495",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.527,151.721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.669C0,-1.669 0.591,-0.591 -0.195,0C-0.379,-0.301 -0.609,-0.495 0,-1.669",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.158,151.049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.547C0,-1.547 1.156,-1.496 0.698,-0.146C0.357,-0.138 0.028,0 0,-1.547",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.489,148.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.175C0,1.175 0.313,-0.333 1.171,0.591C1.096,1.042 1.116,1.508 0,1.175",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.515,148.091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.403C0,1.403 0.986,1.258 0.771,0.075C0.483,0.097 0.222,0 0,1.403",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.133,146.772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.487C0,2.487 1.176,1.289 0.24,0C-0.115,0.324 -0.503,0.47 0,2.487",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.536,147.412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.506C0,2.506 1.092,1.169 0.074,0C-0.258,0.366 -0.635,0.558 0,2.506",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.498,148.665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.953C0,1.953 0.783,0.816 -0.065,0C-0.306,0.313 -0.589,0.497 0,1.953",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.794,153.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.803C0,-1.803 -0.098,0.557 -2.326,-0.981C-1.647,-1.657 -1.245,-2.36 0,-1.803",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.296,149.095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.969C0,1.969 0.931,0.76 -0.523,0C-0.549,0.786 -0.689,1.398 0,1.969",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.324,150.091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.519C0,2.519 1.417,1.657 -0.006,0C-0.27,0.877 -0.611,1.495 0,2.519",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.6,148.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.722C0,1.722 0.711,0.635 -0.752,0C-0.672,0.693 -0.721,1.236 0,1.722",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.256,151.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.385C0,-1.385 0.375,0 -1.183,-0.134C-0.917,-0.749 -0.815,-1.287 0,-1.385",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.419,155.867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.809C0,-2.809 0.485,0.057 -2,-0.691C-1.523,-1.831 -1.315,-2.866 0,-2.809",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.026,146.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.426C0,-1.426 -0.468,1.023 -2.26,-0.475C-1.755,-1.336 -1.283,-2.449 0,-1.426",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.12,147.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.782C0,-0.782 -0.623,1.047 -1.87,-0.471C-1.384,-1.048 -0.898,-1.829 0,-0.782",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.344,144.384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.885C0,2.885 1.505,2.414 0.386,0C-0.11,0.609 -0.77,1.16 0,2.885",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.718,149.791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.556C0,-0.556 -0.631,1.354 -2.165,-0.597C-1.628,-1.14 -1.102,-1.91 0,-0.556",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.905,139.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.136C0,1.136 -1.753,2.011 -1.865,-0.837C-1.055,-0.765 -0.111,-0.875 0,1.136",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.767,142.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.196C0,0.196 -1.422,1.836 -2.253,-0.785C-1.474,-1.096 -0.616,-1.64 0,0.196",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.518,144.648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.559C0,2.559 0.315,-0.608 1.951,0.324C1.54,1.602 1.169,3.167 0,2.559",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.36,153.131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.216C0,-0.216 1.336,-2.082 2.475,0.891C1.684,1.247 0.833,1.866 0,-0.216",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.321,157.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.875C0,-0.875 1.855,-1.663 1.907,0.695C1.06,0.664 0.07,0.788 0,-0.875",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.751,154.724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.358C0,0.358 1.204,-1.249 1.936,0.547C1.272,0.978 0.542,1.607 0,0.358",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.912,142.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.487C0,-0.487 0.745,-0.947 1.523,0.438C0.59,0.46 -0.023,0.457 0,-0.487",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.035,143.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.64C0,-0.64 0.979,-1.245 2.001,0.576C0.776,0.605 -0.03,0.6 0,-0.64",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.947,141.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.543C0,-1.543 1.057,-1.819 1.734,0.276C0.538,-0.086 -0.245,-0.347 0,-1.543",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.227,138.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.92C0,2.92 -0.925,2.175 -0.403,0C0.313,1.347 0.77,2.247 0,2.92",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.964,139.922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.84C0,1.84 1.18,1.612 0.877,0C0.445,0.041 -0.264,0.314 0,1.84",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.443,143.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.083C0,2.083 1.097,1.452 0.499,0C0.089,0.19 -0.545,0.7 0,2.083",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.402,141.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.138C0,2.138 1.049,1.369 0.351,0C-0.043,0.242 -0.639,0.831 0,2.138",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,443.784,143.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.016C0,-0.016 -0.825,-1.181 -1.615,0.092C-1.338,0.543 -0.761,1.165 0,-0.016",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.87,151.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.87C0,-1.87 -0.282,-0.136 0.902,0C1.004,-0.498 1.203,-0.9 0,-1.87",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.086,151.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.993C0,-1.993 0.032,0 1.351,-0.278C1.364,-0.857 1.503,-1.369 0,-1.993",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.795,152.609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.992C0,-1.992 0.061,0 1.376,-0.314C1.381,-0.893 1.512,-1.408 0,-1.992",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.241,152.717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.373C-5.021,1.513 -10.285,0.668 -15.636,0.875C-10.365,0 -4.738,0.909 0,3.373",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.453,158.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.303C-1.119,-4.171 -2.077,-3.805 -3.037,-3.281C-4.406,-2.022 -5.308,-0.319 -7.013,0.632L-7.056,0.591C-6.127,-1.095 -4.659,-2.285 -3.157,-3.435C-2.39,-4.288 -1.115,-4.935 0.012,-4.362L0,-4.303Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,432.242,150.205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.145C-0.211,2.908 -0.488,2.74 -0.726,2.53C-0.976,2.31 -1.216,2.077 -1.435,1.826C-1.879,1.318 -2.24,0.74 -2.506,0.12C-2.594,-0.085 -2.903,0.092 -2.809,0.298C-2.518,0.938 -2.138,1.535 -1.666,2.057C-1.438,2.309 -1.193,2.541 -0.922,2.747C-0.659,2.946 -0.378,3.161 -0.049,3.23L0,3.145Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.979,146.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.096C-0.212,7.547 -0.634,7.075 -0.888,6.538C-1.175,5.929 -1.374,5.269 -1.471,4.602C-1.677,3.179 -1.41,1.717 -0.76,0.44C-0.618,0.161 -1.039,-0.086 -1.18,0.194C-1.858,1.538 -2.124,3.067 -1.917,4.56C-1.82,5.256 -1.621,5.933 -1.322,6.569C-1.061,7.126 -0.677,7.877 -0.112,8.182L0,8.096Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.178,149.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.932C0,0.932 -0.278,-0.007 -1.026,0.391C-0.959,0.669 -0.975,0.939 0,0.932",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.706,147.609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.043C0,0.043 0.721,-0.577 1.137,0.193C0.936,0.385 0.808,0.62 0,0.043",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.358,147.878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.157C0,1.157 0.014,0 0.939,0.422C0.951,0.763 1.05,1.088 0,1.157",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.645,146.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.155C0,1.155 -1.03,0.883 -0.418,0C-0.11,0.063 0.206,0.031 0,1.155",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.346,147.697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.981C0,0.981 -0.117,0 -0.916,0.245C-0.896,0.533 -0.957,0.797 0,0.981",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.229,150.478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.588C0,0.588 -0.835,-0.556 -1.693,0.414C-1.467,0.761 -1.361,1.144 0,0.588",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.706,152.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.37C0,0.37 -0.928,-0.686 -1.703,0.363C-1.449,0.685 -1.312,1.056 0,0.37",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.2,153.539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.125C0,0.125 -0.786,-0.627 -1.326,0.242C-1.108,0.474 -0.979,0.752 0,0.125",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,433.44,158.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.234C0,-2.234 1.672,-1.832 0.687,0C0.093,-0.482 -0.672,-0.924 0,-2.234",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,434.77,156.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.861C0,-1.861 1.254,-1.287 0.245,0C-0.156,-0.47 -0.695,-0.935 0,-1.861",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,434.945,154.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.677C0,0.677 -0.347,-0.815 -1.967,0.368C-1.544,0.848 -1.158,1.492 0,0.677",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.274,156.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.165C0,-2.165 1.309,-1.585 0.012,0C-0.367,-0.522 -0.9,-1.027 0,-2.165",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.608,155.431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.917C0,-1.917 0.626,-0.188 -1.307,0C-1.272,-0.812 -1.364,-1.753 0,-1.917",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.854,155.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.279C0,-2.279 1.14,-0.901 -0.626,0C-0.851,-0.771 -1.236,-1.614 0,-2.279",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,434.883,151.843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.891C0,1.891 -2.157,1.66 -1.554,0C-0.678,0.377 0.392,0.706 0,1.891",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.781,152.237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.503C0,2.503 -1.292,1.217 0.708,0C0.963,0.781 1.4,1.614 0,2.503",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,441.271,153.734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.948C0,1.948 -0.569,0.115 1.032,0C1.026,0.847 1.129,1.834 0,1.948",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.264,153.351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.94C0,1.94 -1.114,0.779 0.093,0C0.398,0.652 0.839,1.365 0,1.94",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.138,150.939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.547C0,1.547 -0.326,0.815 0.601,0C0.633,0.932 0.642,1.545 0,1.547",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.974,151.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.033C0,2.033 -0.428,1.07 0.79,0C0.832,1.224 0.843,2.03 0,2.033",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.053,149.926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.568C0,1.568 -0.206,0.519 1.205,-0.213C0.98,0.991 0.817,1.781 0,1.568",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.613,152.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.193C0,-0.193 -0.489,0.751 -1.976,0.288C-1.074,-0.464 -0.471,-0.944 0,-0.193",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,431.266,157.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.87C0,0.87 -0.176,-0.304 -1.265,0.042C-1.23,0.473 -1.032,1.174 0,0.87",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,433.731,155.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.499C0,0.499 -0.449,-0.581 -1.424,0.056C-1.288,0.461 -0.93,1.08 0,0.499",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,432.642,156.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.355C0,0.355 -0.541,-0.673 -1.458,0.061C-1.287,0.449 -0.877,1.028 0,0.355",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,432.161,159.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.612C0,-1.612 -0.777,-0.756 0.103,0C0.404,-0.289 0.816,-0.882 0,-1.612",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.17,149.337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.993C0,0.993 1.183,1.229 1.254,0.042C0.914,-0.047 0.637,-0.236 0,0.993",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.485,150.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.519C0,1.519 1.353,1.434 1.141,0.123C0.747,0.125 0.397,0 0,1.519",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.194,151.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.527C0,1.527 1.352,1.413 1.115,0.107C0.721,0.118 0.369,0 0,1.527",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.093,147.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.719C5.717,6.176 11.126,3.73 15.755,0C11.583,4.226 5.835,6.833 0,7.719",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.701,145.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.349C1.093,7.362 2.002,6.023 1.773,4.52C1.596,3.045 1.36,1.311 1.846,-0.055C2.487,2.224 2.153,4.567 1.786,6.861C1.525,7.628 0.828,8.297 0.024,8.404L0,8.349Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.151,151.854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.749C0.359,-0.696 0.721,-0.723 1.082,-0.706C1.506,-0.686 1.933,-0.645 2.352,-0.576C3.19,-0.439 4.014,-0.199 4.792,0.144C5.023,0.246 5.163,-0.079 4.927,-0.177C4.115,-0.517 3.268,-0.77 2.396,-0.897C1.988,-0.957 1.579,-0.995 1.166,-0.993C0.775,-0.99 0.369,-0.987 0,-0.847L0,-0.749Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.789,148.827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.669C0.906,5.176 1.133,3.839 0.954,2.919C0.743,1.836 0.038,0.889 -0.81,0.21C-1.072,0 -1.447,0.373 -1.182,0.582C-0.434,1.174 0.199,1.966 0.448,2.9C0.568,3.349 0.593,3.822 0.494,4.278C0.388,4.764 0.122,5.13 -0.116,5.553L0,5.669Z",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.201,159.476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-5.84C3.16,-5.445 6.98,-3.316 7.551,0C5.973,-2.927 3.173,-5.112 0,-5.84",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,455.699,156.309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.021C0,0.021 1.061,0.614 1.363,-0.178C1.062,-0.362 0.84,-0.593 0,0.021",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,457.255,159.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.956C0,-0.956 -0.086,0 -1.118,-0.369C-1.111,-0.651 -1.205,-0.923 0,-0.956",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.352,158.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.186C0,-1.186 0.996,-0.233 -0.174,0C-0.482,-0.271 -0.852,-0.474 0,-1.186",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,457.273,159.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.626C0,-0.626 1.132,-1.046 1.37,0.056C1.047,0.196 0.801,0.42 0,-0.626",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.673,157.765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.282C0,-0.282 0.957,0.447 1.437,-0.253C1.169,-0.475 0.992,-0.729 0,-0.282",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,454.693,154.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.891C0,0.891 1.722,1.304 1.622,-0.024C1.124,-0.166 0.697,-0.413 0,0.891",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.903,153.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.096C0,1.096 1.726,1.379 1.486,0.039C0.984,-0.066 0.541,-0.283 0,1.096",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.586,152.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1C0,1 1.339,1.123 1.049,0.077C0.658,0.023 0.303,-0.123 0,1",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.495,151.781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.533C0,0.533 -1.424,1.506 -2.529,-0.973C-1.543,-0.728 -0.789,-0.718 0,0.533",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.493,150.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.087C0,1.087 1.511,1.298 0.652,-0.211C0.183,0.118 -0.288,0.278 0,1.087",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.528,152.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.37C0,0.37 1.745,1.127 1.423,-0.757C0.691,-0.579 0.039,-0.578 0,0.37",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.447,148.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.284C0,1.284 1.247,1.372 0.309,-0.088C-0.013,0.285 -0.364,0.487 0,1.284",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.85,150.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.307C0,-0.307 -0.452,0.613 -1.758,-0.701C-1.174,-0.762 -0.779,-0.92 0,-0.307",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.359,153.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.583C0,-0.583 -1.194,1.084 -2.974,-1.249C-1.905,-1.373 -1.134,-1.667 0,-0.583",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.566,148.686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.774C0,0.774 -1.803,1.489 -2.544,-0.621C-1.607,-0.598 -0.559,-0.715 0,0.774",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.412,150.173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.053C0,1.053 -1.589,1.367 -1.835,-0.314C-1.077,-0.18 -0.203,-0.137 0,1.053",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.461,151.138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.387C0,0.387 1.602,1.388 1.977,-0.588C1.192,-0.716 0.295,-1.001 0,0.387",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.678,151.286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.416C0,1.416 -1.642,1.76 -1.897,-0.344C-1.113,-0.154 -0.21,-0.075 0,1.416",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,457.44,147.573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.381C0,2.381 -2.051,1.361 -0.536,0C0.142,0.685 1.041,1.396 0,2.381",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.28,148.407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.251C0,2.251 -2.191,1.837 -1.443,0C-0.575,0.489 0.494,0.937 0,2.251",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.537,152.496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.054C0,-0.054 2.074,-1.212 2.997,0.52C1.908,0.759 0.693,1.158 0,-0.054",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.274,156.538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.485C0,-2.485 2.243,-2.241 1.568,0C0.665,-0.478 -0.441,-0.886 0,-2.485",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.292,157.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.235C0,-2.235 2.092,-1.093 0.802,0C0.068,-0.696 -0.881,-1.438 0,-2.235",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.507,156.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.642C0,-1.642 1.979,-1.389 1.61,0C0.776,-0.342 -0.227,-0.649 0,-1.642",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,457.876,152.761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.638C0,-1.638 0.922,-1.243 0.826,0C-0.013,-0.741 -0.555,-1.236 0,-1.638",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.413,153.108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.152C0,-2.152 1.211,-1.633 1.086,0C-0.017,-0.973 -0.73,-1.624 0,-2.152",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,459.683,153.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.206C0,-2.206 1.093,-1.478 0.507,0C-0.349,-1.124 -0.895,-1.87 0,-2.206",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,458.589,149.729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.307C0,1.307 -0.398,0.231 1.297,-0.319C1.169,0.858 1.064,1.626 0,1.307",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.583,146.305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.045C0,0.045 1.176,0.893 1.821,-0.069C1.414,-0.398 0.631,-0.848 0,0.045",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.687,149.539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.453C0,0.453 1.331,1.055 1.623,-0.074C1.152,-0.319 0.301,-0.602 0,0.453",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.689,147.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.596C0,0.596 1.366,1.097 1.523,-0.074C1.036,-0.284 0.174,-0.501 0,0.596",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,452.551,146.354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.252C0,1.252 -0.072,0.068 -1.494,0C-1.504,0.424 -1.345,1.165 0,1.252",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,455.386,157.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.559C0,-1.559 -1.233,-1.014 -0.26,0C0.113,-0.14 0.518,-0.158 0,-1.559",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,453.567,156.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.852C0,-1.852 -1.101,-0.938 0.227,0C0.567,-0.248 0.98,-0.364 0,-1.852",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,451.85,156.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.855C0,-1.855 -1.074,-0.918 0.269,0C0.602,-0.254 1.01,-0.378 0,-1.855",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.822,158.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.079C-1.872,-3.656 -3.019,-1.864 -2.996,0C-3.414,-1.854 -1.966,-4.039 0,-4.079",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.867,157.981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.303C0,-2.303 1.605,-2.268 0.601,0C0.129,-0.661 -0.356,-1.044 0,-2.303",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.349,156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.195C0,0.195 -0.838,-0.704 -1.328,0.77C-0.793,0.776 -0.375,0.899 0,0.195",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.381,154.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.756C0,0.756 -0.611,-0.638 -1.711,0.829C-1.11,1.07 -0.685,1.394 0,0.756",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.831,158.027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.115C0,-0.115 -0.751,-0.797 -1.156,0.682C-0.687,0.584 -0.317,0.619 0,-0.115",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.032,157.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.737C0,-0.737 0.934,-1.149 0.871,0.412C0.448,0.163 0.081,0.076 0,-0.737",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.683,156.402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.382C0,-1.382 1.938,-1.943 1.475,0.561C0.692,0.114 -0.015,-0.066 0,-1.382",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.262,159.829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.016C0.531,-3.978 0.017,-0.909 -2.049,0C-0.678,-1.726 0.219,-3.852 0,-6.016",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.786,158.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.789C0,-0.789 -0.138,0 0.447,-0.018C0.497,-0.246 0.596,-0.438 0,-0.789",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.707,158.773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.529C0,0.529 -0.642,0.718 -0.643,0.003C-0.458,-0.064 -0.303,-0.189 0,0.529",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.373,158.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.506C0,-0.506 -0.388,0.334 -0.812,-0.312C-0.708,-0.566 -0.662,-0.84 0,-0.506",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.757,160.292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.997C0,-0.997 0.538,-0.421 -0.124,0C-0.291,-0.159 -0.494,-0.251 0,-0.997",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.263,159.557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.873C0,-0.873 -0.251,-0.113 0.316,0C0.398,-0.217 0.522,-0.388 0,-0.873",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.117,158.123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.142C0,-1.142 0.134,0 0.974,-0.395C0.95,-0.731 1.011,-1.05 0,-1.142",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.344,156.741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.089C0,-1.089 0.219,0.022 1.035,-0.46C0.985,-0.789 1.023,-1.111 0,-1.089",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.377,155.465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.738C0,-0.738 0.232,0.1 0.845,-0.339C0.789,-0.588 0.801,-0.838 0,-0.738",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,446.912,157.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.06C0,-0.06 -0.643,-0.665 -1.075,0.177C-0.897,0.366 -0.79,0.605 0,-0.06",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.3,156.661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.532C0,-0.532 -0.852,-0.965 -1.152,0.071C-0.911,0.214 -0.74,0.433 0,-0.532",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,447.283,155.516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.57C0,-0.57 -0.86,-0.981 -1.144,0.06C-0.901,0.196 -0.725,0.411 0,-0.57",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.161,157.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.551C1.127,-2.367 2.801,-1.275 2.446,0C2.067,-0.508 1.793,-0.96 1.431,-1.459C0.9,-2.13 0.308,-2.275 0,-2.551",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.015,156.095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.062C0,-0.062 0.355,0.206 0.495,-0.088C0.395,-0.171 0.325,-0.268 0,-0.062",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.482,157.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.334C0,-0.334 -0.069,0.032 -0.423,-0.149C-0.409,-0.257 -0.432,-0.366 0,-0.334",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.213,156.844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.451C0,-0.451 0.318,-0.046 -0.11,0C-0.209,-0.116 -0.333,-0.208 0,-0.451",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.491,157.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.314C0,-0.314 0.421,-0.434 0.462,-0C0.341,0.042 0.244,0.12 0,-0.314",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.317,156.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.181C0,-0.181 0.313,0.136 0.512,-0.117C0.426,-0.212 0.372,-0.317 0,-0.181",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.69,155.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.254C0,0.254 0.599,0.477 0.616,-0.039C0.444,-0.112 0.301,-0.223 0,0.254",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.09,154.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.339C0,0.339 0.606,0.512 0.573,-0.014C0.398,-0.073 0.249,-0.173 0,0.339",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.64,154.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.325C0,0.325 0.474,0.422 0.412,0.008C0.274,-0.028 0.153,-0.097 0,0.325",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.915,156.495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.592C0,-0.592 -0.463,-0.427 -0.155,0C-0.017,-0.04 0.129,-0.032 0,-0.592",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,449.315,156.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.723C0,-0.723 -0.43,-0.411 0.007,0C0.138,-0.083 0.291,-0.112 0,-0.723",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.725,155.788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.726C0,-0.726 -0.421,-0.404 0.022,0C0.151,-0.086 0.302,-0.118 0,-0.726",
    style: {
      fill: "rgb(74,97,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,928.194,-138.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.296,
    y: 244.627,
    width: 12.106,
    height: 79.068,
    style: {
      fill: "rgb(109,91,84)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.466,50.3747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,36.475L331.493,36.475L331.493,0L87.274,0L64.216,9.637L61.987,10.568L50.197,15.496L47.971,16.427L36.549,21.201L34.32,22.132L21.387,27.537L19.158,28.468L6.779,33.642L4.55,34.573L0,36.475Z",
    style: {
      fill: "rgb(79,110,124)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,103.592,50.3761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.311L0,-0.001C0,0.565 1.884,1.024 4.213,1.024L240.756,1.024C239.212,0.283 239.212,-0.596 240.759,-1.335L4.213,-1.335C1.884,-1.335 0,-0.877 0,-0.311",
    style: {
      fill: "rgb(47,75,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.486,91.3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.887L0,-0.186C0,0.817 3.144,1.63 7.023,1.63L454.902,1.63L454.902,-4.517L6.303,-4.517C2.824,-4.517 0,-3.787 0,-2.887",
    style: {
      fill: "rgb(251,248,251)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.486,92.9964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.446L0,-1.816C0,-0.813 3.144,0 7.023,0L454.902,0L454.902,-3.446L0,-3.446Z",
    style: {
      fill: "rgb(225,221,224)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.984,336.453L337.974,336.453L337.974,332.974L342.984,332.974L342.984,336.453ZM277.069,336.453L272.133,336.453L272.133,332.974L277.069,332.974L277.069,336.453ZM262.262,336.453L236.746,336.453L236.746,332.974L262.262,332.974L262.262,336.453ZM175.841,336.453L137.476,336.453L137.476,332.974L175.841,332.974L175.841,336.453ZM76.572,336.453L32.759,336.453L32.759,332.974L76.572,332.974L76.572,336.453Z",
    style: {
      fill: "rgb(231,137,156)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.477,336.453L133.566,336.453L133.566,332.974L137.477,332.974L137.477,336.453ZM80.484,336.453L76.573,336.453L76.573,332.974L80.484,332.974L80.484,336.453Z",
    style: {
      fill: "rgb(222,209,197)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,125.061,92.9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.479L-3.743,3.479L-3.743,2.235L-49.339,2.235L-49.339,3.479L-53.082,3.479L-53.082,0L0,0L0,3.479Z",
    style: {
      fill: "rgb(33,46,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,121.318,95.2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.244L-4.731,1.244L-4.731,0L-5.756,0L-5.756,1.244L-10.412,1.244L-10.412,0L-16.744,0L-16.744,1.244L-27.361,1.244L-27.361,0L-33.693,0L-33.693,1.244L-39.095,1.244L-39.095,0L-40.119,0L-40.119,1.244L-45.595,1.244L-45.595,0L0,0L0,1.244Z",
    style: {
      fill: "rgb(142,186,182)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,190.085,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.128,
    y: 332.974,
    width: 6.333,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,223.984,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.078,
    y: 332.974,
    width: 6.332,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,171.926,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.703,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,240.653,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.066,
    y: 332.974,
    width: 1.025,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,699.812,-239.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.854,
    y: 332.974,
    width: 2.608,
    height: 3.479,
    style: {
      fill: "rgb(231,137,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.973,336.453L334.062,336.453L334.062,332.974L337.973,332.974L337.973,336.453ZM280.98,336.453L277.069,336.453L277.069,332.974L280.98,332.974L280.98,336.453Z",
    style: {
      fill: "rgb(222,209,197)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,325.558,92.9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.479L-3.743,3.479L-3.743,2.235L-49.339,2.235L-49.339,3.479L-53.082,3.479L-53.082,0L0,0L0,3.479Z",
    style: {
      fill: "rgb(33,46,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,321.815,95.2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.244L-4.731,1.244L-4.731,0L-5.756,0L-5.756,1.244L-10.412,1.244L-10.412,0L-16.745,0L-16.745,1.244L-27.361,1.244L-27.361,0L-33.693,0L-33.693,1.244L-39.095,1.244L-39.095,0L-40.119,0L-40.119,1.244L-45.595,1.244L-45.595,0L0,0L0,1.244Z",
    style: {
      fill: "rgb(142,186,182)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,591.08,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.626,
    y: 332.974,
    width: 6.332,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,624.978,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.575,
    y: 332.974,
    width: 6.332,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,572.92,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.2,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,641.647,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.563,
    y: 332.974,
    width: 1.025,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-239.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.746,336.453L232.835,336.453L232.835,332.974L236.746,332.974L236.746,336.453ZM179.753,336.453L175.842,336.453L175.842,332.974L179.753,332.974L179.753,336.453Z",
    style: {
      fill: "rgb(222,209,197)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,224.33,92.9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.479L-3.743,3.479L-3.743,2.235L-49.338,2.235L-49.338,3.479L-53.082,3.479L-53.082,0L0,0L0,3.479Z",
    style: {
      fill: "rgb(33,46,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,220.587,95.2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.244L-4.731,1.244L-4.731,0L-5.756,0L-5.756,1.244L-10.412,1.244L-10.412,0L-16.745,0L-16.745,1.244L-27.361,1.244L-27.361,0L-33.693,0L-33.693,1.244L-39.095,1.244L-39.095,0L-40.119,0L-40.119,1.244L-45.595,1.244L-45.595,0L0,0L0,1.244Z",
    style: {
      fill: "rgb(142,186,182)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,388.623,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.397,
    y: 332.974,
    width: 6.333,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,422.521,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.346,
    y: 332.974,
    width: 6.333,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,370.466,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.973,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,439.192,-237.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.336,
    y: 332.974,
    width: 1.024,
    height: 1.244,
    style: {
      fill: "rgb(33,46,49)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,525.891,-239.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.262,
    y: 332.974,
    width: 9.871,
    height: 3.479,
    style: {
      fill: "rgb(241,208,168)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,687.335,-239.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.984,
    y: 332.974,
    width: 9.871,
    height: 3.479,
    style: {
      fill: "rgb(241,208,168)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,119.082,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,130.659,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,121.335,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,112.255,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,158.271,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,148.947,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,139.867,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,167.654,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.159,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,197.231,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.907,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,178.828,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,224.843,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,215.519,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,206.439,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,234.226,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,264.916,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,255.592,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,246.512,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,292.528,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,283.204,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,274.124,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,301.911,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,331.798,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,322.474,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.394,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,359.409,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,350.086,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,341.006,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.158,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,368.793,49.0405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.359L1.158,2.359C0.782,1.619 0.782,0.74 1.159,0L0,0C-0.259,0.764 -0.259,1.595 0,2.359",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.74,50.375L79.682,60.012L77.453,60.943L65.663,65.871L63.437,66.801L52.015,71.576L49.785,72.506L36.853,77.912L34.624,78.842L22.245,84.017L20.015,84.948L15.466,86.85L346.958,86.85L346.958,50.375L102.74,50.375Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,87.1923,54.4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L259.766,0.931L259.766,0L2.483,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,72.3259,60.0121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L274.633,0.931L274.633,0L2.486,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,56.6938,65.8706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L290.265,0.931L290.265,0L2.483,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,41.4681,71.5755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L305.49,0.931L305.49,0L2.486,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,24.5583,77.9118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L322.4,0.931L322.4,0L2.486,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.22876,84.0171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.931L336.854,0.931L336.854,0L2.795,0L0,0.931Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,464.781,17.0742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,60.495L-130.301,60.495L-130.301,40.044L-59.368,0L0,35.196L0,60.495Z",
    style: {
      fill: "rgb(218,174,114)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,499.41,13.7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,64.253L-44.389,38.625L-44.5,38.561L-93.92,10.029L-187.84,64.253L-187.825,60.882L-187.11,60.479L-187.141,57.622L-187.811,57.996L-187.794,54.197L-93.92,0L-31.105,36.266L-27.02,38.625L-0.047,54.197L-0.029,57.996L-0.7,57.622L-0.731,60.479L-0.016,60.882L0,64.253Z",
    style: {
      fill: "rgb(31,50,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,464.781,26.2711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,60.495L-130.301,60.495L-130.301,40.044L-59.368,0L0,35.196L0,60.495Z",
    style: {
      fill: "rgb(243,158,196)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.602,60.4985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.579C0.718,-0.303 3.673,0.389 3.673,0.389C3.673,0.389 1.507,2.629 1.294,2.85C0.317,4.178 1.467,6.605 2.067,7.659C4.572,12.065 9.723,15.796 16.991,17.152C24.362,18.527 31.103,17.929 36.65,15.785C40.913,14.139 43.98,11.18 46.642,7.631C48.73,4.847 46.084,3.325 49.516,0.68C50.096,0.233 50.99,-0.204 51.391,-0.827C51.391,-1.977 49.586,-4.494 48.752,-5.104C47.128,-6.291 45.693,-7.865 44.241,-9.253C41.235,-12.128 36.121,-17.778 31.923,-18.472C31.761,-18.499 30.401,-18.632 30.167,-18.569C29.487,-18.038 27.498,-16.8 26.339,-16.8C25.411,-16.8 24.753,-17.251 23.963,-17.632C22.433,-18.369 22.073,-18.863 20.163,-18.863C17.609,-18.863 14.429,-16.45 12.591,-14.811C11.383,-13.734 6.287,-8.79 4.932,-7.285C3.481,-5.673 1.421,-3.772 -0.057,-2.581C-0.794,-1.987 -1.141,-1.573 -1.268,-1.355L-1.204,-1.221C-0.882,-0.914 -0.405,-0.735 0,-0.579M-0.961,1.915C-1.976,1.524 -3.144,0.965 -3.635,-0.082C-4.595,-2.124 -3.187,-3.49 -1.734,-4.661C-0.352,-5.776 1.602,-7.58 2.946,-9.073C4.386,-10.673 9.558,-15.687 10.812,-16.805C13.225,-18.958 16.798,-21.535 20.163,-21.535C22.45,-21.535 23.261,-20.937 25.123,-20.039C25.388,-19.911 26.056,-19.473 26.339,-19.473C26.467,-19.473 27.783,-20.098 28.522,-20.676C29.976,-21.811 34.375,-21.256 37.294,-18.993C41.293,-15.893 44.879,-12.286 48.553,-8.819C49.311,-8.103 49.915,-7.564 50.329,-7.261C51.457,-6.437 54.064,-3.223 54.064,-0.827C54.064,1.026 52.385,1.842 51.148,2.796C49.195,4.301 51.227,5.971 48.78,9.234C45.807,13.198 42.371,16.44 37.613,18.278C31.543,20.624 24.292,21.232 16.501,19.779C8.607,18.306 2.706,14.191 -0.257,8.98C-1.551,6.705 -2.753,2.786 -0.359,0.714L0.114,0.224L0.772,2.455C0.772,2.455 -0.058,2.262 -0.961,1.915",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.293901,-0.955836,-0.955836,-0.293901,418.378,41.1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.506,-13.46C-25.314,-6.998 -33.612,28.346 -33.612,28.346C-33.612,28.346 -26.971,31.963 -19.506,25.349C-12.041,18.734 -7.91,-7.968 -7.91,-7.968C-7.91,-7.968 -13.699,-19.923 -19.506,-13.46",
    style: {
      fill: "rgb(31,30,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,398.072,58.5062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.514C0,2.514 -0.088,-1.462 0.205,-1.52C0.497,-1.579 5.906,-1.579 6.461,-1.579C7.017,-1.579 7.397,-1.725 7.426,0.935C7.455,3.596 7.397,3.8 7.397,3.8L7.397,4.239L0.234,3.917L0,2.514Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,391.229,58.5062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.514C0,2.514 -0.08,-1.462 0.186,-1.52C0.452,-1.579 5.372,-1.579 5.878,-1.579C6.383,-1.579 6.729,-1.725 6.756,0.935C6.782,3.596 6.729,3.8 6.729,3.8L6.729,4.239L0.213,3.917L0,2.514Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,385.876,58.5953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.796C0,1.796 0.338,-2.166 0.55,-2.204C0.761,-2.241 4.562,-1.857 4.952,-1.818C5.343,-1.778 5.624,-1.896 5.377,0.752C5.131,3.402 5.069,3.601 5.069,3.601L5.025,4.037L0.023,3.209L0,1.796Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.08px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,419.265,58.5062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.514C0,2.514 0.08,-1.462 -0.186,-1.52C-0.452,-1.579 -5.373,-1.579 -5.878,-1.579C-6.383,-1.579 -6.729,-1.725 -6.755,0.935C-6.782,3.596 -6.729,3.8 -6.729,3.8L-6.729,4.239L-0.213,3.917L0,2.514Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,423.129,58.7988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.514C0,2.514 0.046,-1.462 -0.108,-1.521C-0.261,-1.579 -3.1,-1.579 -3.392,-1.579C-3.684,-1.579 -3.883,-1.725 -3.898,0.935C-3.913,3.596 -3.883,3.8 -3.883,3.8L-3.883,4.239L-0.123,3.917L0,2.514Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.614,58.5655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.513C0,2.513 -0.081,-1.463 0.188,-1.521C0.458,-1.58 5.442,-1.58 5.954,-1.58C6.465,-1.58 6.816,-1.726 6.843,0.935C6.87,3.595 6.815,3.8 6.815,3.8L6.815,4.239L0.216,3.917L0,2.513Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,393.57,54.9383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.264C0,0.264 -1.111,2.544 4.473,2.866C10.057,3.188 11.87,3.45 11.87,1.697C11.87,-0.057 11.811,-1.607 11.811,-1.607L11.548,-3.186L0.409,-3.098L0,0.264Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,388.435,54.0345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.263C0,0.263 -0.494,2.544 1.986,2.865C4.467,3.187 5.272,3.45 5.272,1.696C5.272,-0.058 5.246,-1.608 5.246,-1.608L5.129,-3.187L0.181,-3.099L0,0.263Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.06px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,422.58,53.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.513C0,1.513 0.215,3.836 -2.286,3.857C-4.787,3.878 -5.618,4.042 -5.406,2.301C-5.196,0.559 -4.983,-0.976 -4.983,-0.976L-4.677,-2.529L0.224,-1.847L0,1.513Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.06px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,417.338,54.6763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.263C0,0.263 1.111,2.544 -4.473,2.865C-10.057,3.186 -11.87,3.45 -11.87,1.696C-11.87,-0.059 -11.811,-1.608 -11.811,-1.608L-11.548,-3.187L-0.409,-3.099L0,0.263Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,383.958,61.1549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.633C3.011,-2.197 4.999,-0.89 6.752,-0.61C8.504,-0.331 11.349,-0.153 12.315,-0.026C13.28,0.1 16.074,-0.052 17.954,0.507C19.833,1.066 22.806,1.218 23.847,0.939C24.888,0.66 26.413,0.66 28.698,0.202C30.984,-0.255 33.246,-0.585 34.896,-0.712C36.547,-0.839 37.233,-1.423 37.843,-1.652C38.452,-1.881 44.793,-2.168 41.696,-2.216C39.6,-2.425 36.98,-3.76 35.404,-4.472C33.83,-5.183 31.289,-6.275 30.07,-7.19C28.851,-8.104 26.463,-9.424 24.075,-8.637C23.003,-8.283 22.237,-7.95 21.51,-8.002C20.619,-8.066 19.785,-8.564 18.512,-8.536C16.201,-8.485 13.94,-8.714 11.197,-7.24C8.454,-5.767 4.994,-3.585 4.389,-3.303C2.103,-2.235 -4.502,-0.791 0,-1.633M-3.281,0.497C-3.281,0.497 -6.261,-0.197 -6.782,-1.306C-7.303,-2.414 -6.682,-3.124 -5.252,-4.277C-3.821,-5.431 -1.815,-7.283 -0.417,-8.835C0.98,-10.388 6.115,-15.367 7.345,-16.464C8.576,-17.562 12.456,-20.856 15.806,-20.856C18.401,-20.856 19.588,-19.78 20.187,-19.492C20.786,-19.203 21.34,-18.793 21.983,-18.793C22.626,-18.793 24.279,-19.725 24.988,-20.279C25.698,-20.833 29.358,-20.734 32.119,-18.594C34.88,-16.453 39.074,-12.534 40.809,-10.875C42.544,-9.215 44.204,-7.556 45.184,-6.839C46.165,-6.122 48.372,-3.256 48.372,-1.483C48.372,-0.352 46.882,0.383 45.976,1.082C45.071,1.779 44.562,2.1 44.543,3.571C44.524,5.042 44.713,5.966 43.355,7.776C41.997,9.587 38.584,14.132 32.775,16.375C26.967,18.62 19.971,19.223 12.39,17.809C4.809,16.394 -0.717,12.472 -3.451,7.663C-6.186,2.854 -3.81,1.044 -3.81,1.044L-3.281,0.497Z",
    style: {
      fill: "rgb(221,30,45)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,383.958,61.1549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.633C3.011,-2.197 4.999,-0.89 6.752,-0.61C8.504,-0.331 11.349,-0.153 12.315,-0.026C13.28,0.1 16.074,-0.052 17.954,0.507C19.833,1.066 22.806,1.218 23.847,0.939C24.888,0.66 26.413,0.66 28.698,0.202C30.984,-0.255 33.246,-0.585 34.896,-0.712C36.547,-0.839 37.233,-1.423 37.843,-1.652C38.452,-1.881 44.793,-2.168 41.696,-2.216C39.6,-2.425 36.98,-3.76 35.404,-4.472C33.83,-5.183 31.289,-6.275 30.07,-7.19C28.851,-8.104 26.463,-9.424 24.075,-8.637C23.003,-8.283 22.237,-7.95 21.51,-8.002C20.619,-8.066 19.785,-8.564 18.512,-8.536C16.201,-8.485 13.94,-8.714 11.197,-7.24C8.454,-5.767 4.994,-3.585 4.389,-3.303C2.103,-2.235 -4.502,-0.791 0,-1.633ZM-3.281,0.497C-3.281,0.497 -6.261,-0.197 -6.782,-1.306C-7.303,-2.414 -6.682,-3.124 -5.252,-4.277C-3.821,-5.431 -1.815,-7.283 -0.417,-8.835C0.98,-10.388 6.115,-15.367 7.345,-16.464C8.576,-17.562 12.456,-20.856 15.806,-20.856C18.401,-20.856 19.588,-19.78 20.187,-19.492C20.786,-19.203 21.34,-18.793 21.983,-18.793C22.626,-18.793 24.279,-19.725 24.988,-20.279C25.698,-20.833 29.358,-20.734 32.119,-18.594C34.88,-16.453 39.074,-12.534 40.809,-10.875C42.544,-9.215 44.204,-7.556 45.184,-6.839C46.165,-6.122 48.372,-3.256 48.372,-1.483C48.372,-0.352 46.882,0.383 45.976,1.082C45.071,1.779 44.562,2.1 44.543,3.571C44.524,5.042 44.713,5.966 43.355,7.776C41.997,9.587 38.584,14.132 32.775,16.375C26.967,18.62 19.971,19.223 12.39,17.809C4.809,16.394 -0.717,12.472 -3.451,7.663C-6.186,2.854 -3.81,1.044 -3.81,1.044L-3.281,0.497Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(31,30,27)",
      strokeWidth: "0.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,395.54,70.6789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.094C-0.049,-0.539 -0.678,-0.453 -1.002,-0.31C-1.624,-0.037 -2.236,1.245 -2.133,2.078C-1.367,2.369 0.052,0.362 0,-0.094M0.836,0.348C1.367,2.708 3.263,6.177 5.919,6.977C8.416,7.728 9.296,7.093 9.802,6.657C10.053,6.44 10.184,6.113 10.667,6.112C10.871,6.887 10.207,7.255 9.655,7.569C7.286,8.912 3.694,7.09 2.553,5.814C1.612,4.76 0.632,3.04 0.27,1.648C-0.072,2.13 -0.511,2.939 -1.514,3.131C-2.126,3.248 -2.845,2.518 -2.949,2.021C-3.088,1.356 -2.838,0.447 -2.457,-0.046C-1.962,-0.69 -1.599,-1.089 -1.121,-1.363C-0.538,-1.697 0.372,-1.644 0.551,-0.921C1.241,-2.093 2.095,-4.006 2.793,-5.633C3.166,-6.505 3.852,-7.918 2.503,-7.801C2.068,-7.763 1.309,-7.523 1.023,-7.212C0.751,-6.918 0.34,-6.613 0.148,-6.902C-0.055,-7.33 0.502,-7.497 0.994,-7.757C2.006,-8.293 4.176,-9.006 4.503,-7.278C4.549,-7.037 4.205,-6.109 4.1,-5.887C3.559,-4.74 3.33,-4.345 2.714,-3.169C2.084,-1.966 1.444,-0.508 0.836,0.348",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,424.151,63.9924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.154C0.721,4.499 0.529,2.292 1.245,1.787C1.004,1.402 0.603,1.699 0.346,2.213C0.055,2.797 -0.191,4.039 0,4.154M-0.481,0.475C0.085,-0.57 0.912,-1.139 0.735,-1.743C0.658,-1.872 0.487,-1.653 0.445,-1.642C-0.185,-0.701 -0.218,-0.703 -0.481,0.475M1.011,-2.122C1.598,-2 0.57,-0.435 -0.127,0.502C-0.342,0.79 -0.592,1.146 -0.721,1.442C-0.898,1.848 -1.13,3.03 -1.259,3.491C-1.391,3.963 -1.524,4.557 -1.506,5.141C-1.273,5.411 -0.696,3.964 -0.347,3.572C-0.241,2.715 0.102,0.908 1.153,1.293C1.421,1.391 1.322,1.343 1.556,1.598C1.634,2.501 0.872,2.786 0.983,3.721C1.004,4.161 1.542,3.437 1.733,2.896C1.815,2.663 1.881,2.182 2.122,2.132C2.32,2.132 1.841,3.441 1.563,3.796C1.205,4.249 0.962,4.316 0.806,4.303C0.703,4.221 0.75,4.275 0.721,4.073C0.41,4.482 -0.263,5.221 -0.354,4.201C-0.5,4.443 -1.546,6.362 -1.853,5.378C-2.096,4.597 -1.334,2.999 -1.337,2.341C-1.516,2.373 -1.689,2.996 -2.001,3.025C-1.966,2.6 -1.248,1.641 -0.997,1.3C-0.778,0.313 -0.721,-0.21 -0.219,-1.236C-0.006,-1.671 0.441,-2.208 1.011,-2.122",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,413.62,65.1915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.164C-0.641,7.971 -2.217,9.414 -2.892,8.155C-3.745,6.562 -2.273,4.474 -2.017,3.195C-2.344,3.207 -2.819,3.537 -3.08,3.195C-3.294,2.717 -2.41,2.486 -1.66,2.137C-1.371,1.598 -1.308,1.072 -0.982,0.233C-0.558,-0.86 -0.187,-2.25 0.545,-1.824C0.723,-1.722 -0.385,0.483 -0.829,1.899C-0.361,1.71 0.519,1.031 0.634,1.36C0.568,2.447 -0.418,2.54 -1.054,2.845C-1.324,3.476 -1.635,4.205 -1.903,4.995C-2.123,5.644 -2.625,7.454 -2.109,7.894C-1.829,8.134 -0.404,7.137 0.062,6.498C0.348,5.473 1.705,2.862 1.526,2.376C1.357,1.897 0.768,3.339 0.571,2.904C0.423,1.716 2.351,0.61 2.053,2.332C2.8,1.845 3.418,0.165 3.892,0.54C4.088,0.676 2.937,2.136 2.571,2.718C2.218,3.277 1.822,3.705 1.58,4.304C1.41,4.721 1.062,5.644 0.928,6.199C0.576,7.659 0.535,8.11 0.294,8.025C-0.008,7.919 -0.079,7.493 0,7.164",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,417.129,65.6158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.229C0.335,5.486 0.75,5.023 0.962,4.78C1.208,3.385 1.433,1.938 1.909,1.036C1.181,-0.655 -0.228,3.113 0,5.229M1.535,4.837C1.726,5.29 2.031,4.654 2.27,4.329C2.503,4.011 2.683,3.338 2.871,2.936C3.044,2.568 3.219,1.578 3.486,1.537C3.741,1.57 3.413,2.395 3.281,2.815C2.998,3.714 2.708,4.89 1.676,5.77C1.541,5.885 1.005,6.088 0.962,5.635C0.623,6.048 0.262,6.554 -0.375,6.331C-0.682,6.224 -0.649,5.479 -0.597,4.353C-0.498,2.244 1.28,-1.325 2.277,0.177C2.401,0.363 2.448,0.718 2.309,1.572C2.195,2.268 1.45,4.593 1.535,4.837",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.072,69.1693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.043C-0.177,4.786 0.411,3.668 0.969,3.542C1.238,3.555 0.693,4.205 1.061,4.482C1.963,5.162 3.516,3.54 3.812,2.595C4.144,1.532 4.178,0.653 4.055,0.041C3.889,-0.79 3.903,-1.156 2.812,-0.077C1.714,1.008 0.906,2.75 -0.163,3.995C-0.878,4.828 -1.63,5.668 -2.652,5.334C-2.934,5.223 -3.317,4.73 -3.295,4.191C-3.905,4.845 -6.271,5.597 -6.329,3.63C-6.356,2.719 -5.685,2.022 -5.325,1.222C-5.014,0.533 -4.653,-0.455 -4.823,-0.577C-5.157,-0.797 -5.56,0.093 -5.94,-0.428C-5.873,-0.922 -5.407,-1.189 -5.014,-1.341C-4.451,-1.559 -3.915,-1.446 -3.854,-0.631C-3.83,-0.301 -3.886,0.002 -4.045,0.404C-4.327,1.116 -4.702,1.951 -4.984,2.616C-5.199,3.123 -5.308,3.565 -5.148,3.866C-4.378,4.191 -3.29,3.476 -2.822,2.588C-2.401,1.789 -2.029,0.586 -1.591,-0.266C-1.288,-0.856 -1.013,-1.314 -0.424,-1.205C-0.113,-1.138 -0.903,0.337 -1.329,1.141C-1.539,1.536 -1.88,2.252 -2.082,2.891C-2.263,3.463 -2.418,4.162 -2.183,4.325C-1.518,4.649 -0.831,3.874 -0.183,3.063C0.792,1.843 1.791,0.002 2.609,-0.901C3.552,-1.943 4.561,-1.746 4.758,0.168C5.105,3.543 2.259,6.986 0,5.043",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,386.02,66.3526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.673C0.417,2.7 0.516,0.942 -0.014,-0.675C0.59,-1.747 0.138,0.189 0.856,0.245C1.707,0.311 1.69,-0.465 2.157,-0.195C2.27,-0.113 2.341,0.069 2.334,0.231C2.291,1.239 2.034,1.685 1.683,2.389C2.056,2.135 2.176,1.722 2.567,1.814C3.279,1.982 2.592,3.858 3.069,4.343C3.6,4.513 3.608,3.187 3.529,2.321C3.448,1.438 3.051,0.72 3.133,0.529C3.826,-0.492 3.532,1.46 4.257,1.517C4.827,1.561 4.63,1.18 5.184,1.192C5.36,1.246 4.986,1.922 4.024,2.173C4.01,3.572 4.095,5.141 2.822,4.878C2.418,4.605 2.612,2.835 2.411,2.375C2.006,2.053 1.73,3.954 1.11,3.708C0.75,3.471 0.885,3.044 0.997,2.815C1.371,2.052 1.773,1.194 1.86,0.61C1.938,-0.134 1.457,0.766 0.7,0.719C0.902,2.143 0.636,2.991 -0.035,3.018C-0.859,3.052 -0.619,1.618 -0.698,1.072C-0.759,0.654 -0.844,0.89 -1.471,1.388C-1.831,1.674 -2.265,1.952 -2.175,1.079C-2.107,0.412 -1.829,0.216 -1.45,-0.587C-1.365,-0.763 -2.072,-0.438 -2.39,-0.539C-2.195,0.88 -2.581,0.948 -3.288,1.063C-3.72,1.077 -3.812,0.759 -3.847,0.279C-3.875,-0.472 -3.668,-0.645 -4.13,-0.472C-4.851,-0.201 -5.021,-0.302 -5.155,-0.384C-5.438,-1.107 -4.745,-1.087 -4.505,-1.588C-4.26,-2.004 -4.875,-1.484 -4.965,-1.689C-4.821,-2.223 -4.089,-2.468 -3.883,-1.838C-3.687,-1.24 -5.165,-0.672 -4.293,-0.857C-3.82,-0.942 -3.769,-1.087 -3.6,-0.999C-2.957,-0.666 -3.593,0.495 -3.175,0.624C-2.499,0.436 -2.768,-0.452 -2.977,-1.053C-3.076,-1.338 -3.226,-1.441 -3.189,-1.614C-2.878,-2.129 -2.868,-1.003 -2.15,-0.952C-1.565,-0.91 -1.123,-1.956 -0.806,-0.958C-0.542,-0.127 -1.572,0.214 -1.516,0.883C-1.367,0.687 -1.204,0.258 -0.573,0.38C0.145,0.52 -0.594,2.612 0,2.673",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,391.028,69.7817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.176C-1.069,1.666 -0.103,0 0.494,0.829C0.812,1.27 0.539,1.978 0,2.176",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,421.152,67.9945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.129C-0.53,1.222 0.416,-0.016 0.592,1.017C0.686,1.567 0.367,2.145 0,2.129",
    style: {
      fill: "rgb(31,30,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-201.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.402,320.813L454.155,320.813L454.155,321.592L445.402,321.592L445.402,320.813ZM455.413,309.772L456.238,309.928L454.154,320.944L453.329,320.788L455.413,309.772M444.142,309.802L443.317,309.958L445.401,320.974L446.226,320.818L444.142,309.802M443.325,309.183L456.221,309.183L456.221,309.962L443.325,309.962L443.325,309.183Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,436.898,108.636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.851L0,10.942L8.662,10.942L8.662,11.539L0.091,11.539L0.091,10.851L0,10.851L0,10.942L0,10.851L-0.091,10.851L-0.091,11.63L-0.064,11.695L0,11.722L8.753,11.722L8.817,11.695L8.844,11.63L8.844,10.851L8.817,10.786L8.753,10.76L0,10.76L-0.064,10.786L-0.091,10.851L0,10.851M10.012,-0.19L9.995,-0.101L10.73,0.038L8.68,10.875L8.034,10.753L10.101,-0.173L10.012,-0.19L9.995,-0.101L10.012,-0.19L9.922,-0.207L7.838,10.808L7.853,10.877L7.911,10.915L8.735,11.071L8.804,11.057L8.842,10.998L10.926,-0.017L10.912,-0.085L10.854,-0.124L10.029,-0.28L9.961,-0.266L9.922,-0.207L10.012,-0.19M-1.26,-0.16L-1.277,-0.25L-2.101,-0.094L-2.16,-0.056L-2.174,0.013L-0.09,11.028L-0.052,11.087L0.017,11.101L0.841,10.945L0.9,10.907L0.914,10.839L-1.17,-0.177L-1.208,-0.236L-1.277,-0.25L-1.26,-0.16L-1.349,-0.143L0.718,10.783L0.072,10.905L-1.978,0.068L-1.243,-0.071L-1.26,-0.16L-1.349,-0.143L-1.26,-0.16M-2.076,-0.78L-2.076,-0.688L10.728,-0.688L10.728,-0.091L-1.985,-0.091L-1.985,-0.78L-2.076,-0.78L-2.076,-0.688L-2.076,-0.78L-2.167,-0.78L-2.167,-0L-2.141,0.064L-2.076,0.091L10.82,0.091L10.884,0.064L10.911,-0L10.911,-0.78L10.884,-0.844L10.82,-0.871L-2.076,-0.871L-2.141,-0.844L-2.167,-0.78L-2.076,-0.78Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.467,107.841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.237L-1.739,-0.854L-3.747,0L11.361,0L9.532,-0.824L8.123,-3.237",
    style: {
      fill: "rgb(8,6,6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-179.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.972,
    y: 303.554,
    width: 1.95,
    height: 1.611,
    style: {
      fill: "rgb(8,6,6)",
      stroke: "rgb(8,6,6)",
      strokeWidth: "0.02px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.137,124.262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.09L0.721,-4.09C2.099,-3.298 2.569,-2.006 3.179,0L2.374,0C2.294,-0.876 2.382,-2.977 0,-4.09",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,438.137,124.261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.152L0,-4.026L0.721,-4.026L0.721,-4.089L0.689,-4.035C2.044,-3.257 2.508,-1.989 3.119,0.019L3.179,0.001L3.179,-0.062L2.374,-0.062L2.374,0.001L2.437,-0.005C2.359,-0.869 2.443,-3.02 0.027,-4.146L0,-4.089L0,-4.026L0,-4.152L-0.061,-4.103L-0.027,-4.032C2.321,-2.933 2.229,-0.88 2.312,0.006L2.374,0.063L3.179,0.063L3.23,0.038L3.24,-0.018C2.63,-2.022 2.154,-3.338 0.752,-4.143L0.721,-4.152L0,-4.152Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,441.232,124.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.179,-4.089L-2.458,-4.089C-1.08,-3.297 -0.61,-2.005 0,0L-0.805,0C-0.885,-0.875 -0.797,-2.976 -3.179,-4.089Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.411,124.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.026L0,-4.152L-0.721,-4.152L-0.752,-4.144C-2.154,-3.338 -2.63,-2.022 -3.239,-0.018L-3.23,0.038L-3.179,0.063L-2.374,0.063L-2.311,0.006C-2.229,-0.88 -2.321,-2.933 0.027,-4.032L0.061,-4.103L0,-4.152L0,-4.026L0,-4.089L-0.027,-4.146C-2.443,-3.02 -2.359,-0.869 -2.436,-0.005L-2.374,0L-2.374,-0.062L-3.179,-0.062L-3.179,0L-3.119,0.019C-2.508,-1.989 -2.044,-3.257 -0.689,-4.035L-0.721,-4.089L-0.721,-4.026L0,-4.026Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-221.153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.997,
    y: 324.877,
    width: 3.561,
    height: 0.848,
    style: {
      fill: "rgb(8,6,6)",
      stroke: "rgb(8,6,6)",
      strokeWidth: "0.15px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-222.764)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.658,
    y: 325.852,
    width: 4.239,
    height: 0.509,
    style: {
      fill: "rgb(8,6,6)",
      stroke: "rgb(8,6,6)",
      strokeWidth: "0.15px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.918,102.141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.949C0.024,0.42 1.545,-0.007 3.398,-0.005C5.25,-0.003 6.733,0.427 6.709,0.956",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero",
      stroke: "rgb(8,6,6)",
      strokeWidth: "0.15px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.50394,-192.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.917,
    y: 309.973,
    width: 1.72,
    height: 1.793,
    style: {
      fill: "rgb(28,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.413,119.476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.793L0,-1.744L1.671,-1.744L1.671,-0.049L0.049,-0.049L0.049,-1.793L0,-1.793L0,-1.744L0,-1.793L-0.049,-1.793L-0.049,-0L-0.035,0.035L0,0.049L1.72,0.049L1.755,0.035L1.769,-0L1.769,-1.793L1.755,-1.827L1.72,-1.842L0,-1.842L-0.035,-1.827L-0.049,-1.793L0,-1.793Z",
    style: {
      fill: "rgb(8,6,6)",
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,435.496,108.329)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.175,1.663L9.579,46.083L20.287,46.079L20.287,38.979L20.346,38.829L20.487,38.771L27.654,38.771L27.8,38.829L27.862,38.979L27.862,46.075L38.546,46.071L46.95,1.663L1.175,1.663Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.175,
    y: 1.663,
    width: 45.775,
    height: 44.421
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01999,-0,-0,1.01999,-1846.16,-482.973)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 1811.13,
    y: 475.136,
    width: "45px",
    height: "44px"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,437.176,118.169)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.767,5.083L1.808,5.083L1.129,1.504L1.767,5.083Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.129,
    y: 1.504,
    width: 0.679,
    height: 3.579
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01999,-0,-0,1.01999,-1853.16,-523.973)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 1817.94,
    y: 515.177,
    width: "1px",
    height: "4px"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,435.256,108.329)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.842,1.458L9.129,42.504L9.808,46.083L10.579,46.083L2.175,1.663L47.95,1.663L39.546,46.071L39.567,46.071L48.304,1.458L1.842,1.458Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.842,
    y: 1.458,
    width: 46.462,
    height: 44.625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01999,-0,-0,1.01999,-1845.16,-482.973)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image12",
    x: 1810.8,
    y: 474.936,
    width: "46px",
    height: "44px"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,440.056,117.449)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.692,
    y: 1.179,
    width: 6.762,
    height: 6.896,
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.692,
    y: 1.179,
    width: 6.762,
    height: 6.896
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01999,-0,-0,1.01999,-1865.16,-520.973)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image15",
    x: 1830.26,
    y: 511.918,
    width: "7px",
    height: "7px"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,440.056,117.209)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.487,1.771L1.346,1.829L1.287,1.979L1.287,9.079L1.692,9.075L1.692,2.179L8.454,2.179L8.454,9.075L8.862,9.075L8.862,1.979L8.8,1.829L8.654,1.771L1.487,1.771Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.287,
    y: 1.771,
    width: 7.575,
    height: 7.308
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01999,-0,-0,1.01999,-1865.16,-519.973)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image18",
    x: 1829.86,
    y: 511.517,
    width: "8px",
    height: "8px"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,372.013,125.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.63L-8.501,14.63C-10.194,14.63 -11.566,13.258 -11.566,11.565L-11.566,3.064C-11.566,1.372 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.372 3.065,3.064L3.065,11.565C3.065,13.258 1.693,14.63 0,14.63",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,362.599,135.243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-5.679L0.837,-5.679L1.66,-1.642L1.674,-1.642L2.691,-5.679L3.266,-5.679L4.279,-1.642L4.294,-1.642L5.12,-5.679L5.957,-5.679L4.649,0L3.985,0L2.986,-4.096L2.972,-4.096L1.969,0L1.308,0L0,-5.679Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,372.926,131.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.506C-0.115,3.032 -0.335,3.437 -0.658,3.719C-0.991,3.999 -1.385,4.139 -1.841,4.139C-2.253,4.129 -2.596,4.02 -2.871,3.812C-3.152,3.612 -3.355,3.381 -3.482,3.119L-3.586,2.873C-3.615,2.793 -3.639,2.692 -3.658,2.57C-3.694,2.341 -3.712,1.902 -3.712,1.253C-3.712,0.593 -3.694,0.152 -3.658,-0.071C-3.62,-0.295 -3.561,-0.475 -3.482,-0.613C-3.355,-0.875 -3.152,-1.109 -2.871,-1.314C-2.596,-1.522 -2.252,-1.628 -1.84,-1.633C-1.334,-1.628 -0.923,-1.466 -0.603,-1.147C-0.285,-0.826 -0.084,-0.428 0,0.047L-0.842,0.047C-0.907,-0.182 -1.025,-0.377 -1.195,-0.539C-1.373,-0.692 -1.588,-0.771 -1.843,-0.777C-2.03,-0.771 -2.191,-0.731 -2.325,-0.656C-2.462,-0.578 -2.572,-0.48 -2.656,-0.363C-2.759,-0.241 -2.828,-0.083 -2.861,0.109C-2.9,0.312 -2.919,0.693 -2.919,1.253C-2.919,1.813 -2.9,2.191 -2.861,2.389C-2.828,2.587 -2.759,2.747 -2.656,2.869C-2.572,2.986 -2.461,3.081 -2.325,3.154C-2.19,3.24 -2.029,3.283 -1.843,3.283C-1.396,3.283 -1.062,3.024 -0.842,2.506L0,2.506Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,547.773,107.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.631L-8.501,14.631C-10.194,14.631 -11.566,13.259 -11.566,11.566L-11.566,3.065C-11.566,1.373 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.373 3.065,3.065L3.065,11.566C3.065,13.259 1.693,14.631 0,14.631",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,542.297,114.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.642L2.126,-0.642C2.658,-0.651 3.059,-0.821 3.328,-1.153C3.583,-1.476 3.712,-1.835 3.712,-2.229C3.712,-2.557 3.659,-2.833 3.555,-3.057C3.447,-3.258 3.295,-3.418 3.1,-3.535C2.805,-3.727 2.463,-3.819 2.073,-3.81L0,-3.81L0,-0.642ZM-1.431,-5.202L1.996,-5.202C2.369,-5.202 2.727,-5.167 3.074,-5.095C3.42,-5.001 3.771,-4.81 4.126,-4.519C4.424,-4.301 4.666,-3.988 4.851,-3.582C5.045,-3.189 5.142,-2.725 5.142,-2.19C5.142,-1.467 4.896,-0.808 4.402,-0.215C3.896,0.41 3.156,0.732 2.182,0.75L0,0.75L0,4.56L-1.431,4.56L-1.431,-5.202Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,371.578,107.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.631L-8.501,14.631C-10.194,14.631 -11.566,13.259 -11.566,11.566L-11.566,3.065C-11.566,1.373 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.373 3.065,3.065L3.065,11.566C3.065,13.259 1.693,14.631 0,14.631",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,372.449,118.343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.687L-0.72,-2.687L-0.72,0.97L-9.516,0.97L-9.516,-2.684L-10.243,-2.684L-10.243,-3.657L0,-3.657L0,-2.687Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,370.012,111.966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.467L-2.227,2.467C-2.255,2.246 -2.283,2.027 -2.31,1.809C-2.345,1.531 -2.379,1.252 -2.416,0.974C-2.436,0.824 -2.507,0.764 -2.661,0.764C-3.238,0.763 -3.814,0.764 -4.391,0.764L-4.501,0.764L-4.488,0.716C-4.229,0.332 -3.892,0.064 -3.416,0.012L-3.249,0.044C-2.699,0.332 -2.145,0.351 -1.591,0.066C-1.476,0.007 -1.369,0 -1.251,0.026C-0.767,0.136 -0.438,0.441 -0.21,0.867C-0.075,1.118 -0.005,1.389 -0.001,1.674C0.003,1.935 0,2.196 0,2.467",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00714551,0.999974,0.999974,0.00714551,367.542,109.309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27,-1.259C0.564,-1.262 -0.001,-0.701 -0.002,0C-0.003,0.699 0.561,1.259 1.27,1.26C1.958,1.261 2.521,0.694 2.523,0.001C2.523,-0.69 1.959,-1.258 1.27,-1.259",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,365.924,113.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.494C0.133,0.494 0.243,0.384 0.243,0.251C0.244,0.117 0.135,0.008 0.001,0.008C-0.134,0.008 -0.243,0.116 -0.243,0.25C-0.243,0.384 -0.132,0.494 0,0.494M-1.311,0.977C-1.372,0.492 -1.432,0.013 -1.493,-0.477L-1.399,-0.481C-0.489,-0.481 0.422,-0.48 1.333,-0.483L1.448,-0.383C1.497,0.044 1.553,0.47 1.607,0.897L1.607,0.977L-1.311,0.977Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,40.9481,107.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.631L-8.501,14.631C-10.194,14.631 -11.566,13.259 -11.566,11.566L-11.566,3.065C-11.566,1.373 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.373 3.065,3.065L3.065,11.566C3.065,13.259 1.693,14.631 0,14.631",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,35.7763,120.138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-10.809L-1.548,-4.248L1.448,-5.102L-1.043,0L4.361,-6.633L0.685,-6.633L2.251,-10.809L0,-10.809Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,244.692,107.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.631L-8.501,14.631C-10.194,14.631 -11.566,13.259 -11.566,11.566L-11.566,3.065C-11.566,1.373 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.373 3.065,3.065L3.065,11.566C3.065,13.259 1.693,14.631 0,14.631",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,245.304,114.789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.289L-0.029,1.375C-0.112,1.664 -0.336,1.8 -0.633,1.738C-0.744,1.715 -0.853,1.683 -0.964,1.66L-1.108,1.647L-1.108,3.651C-0.974,3.651 -0.845,3.65 -0.717,3.651L-0.576,3.665C-0.485,3.686 -0.424,3.77 -0.429,3.86C-0.433,3.956 -0.504,4.032 -0.601,4.044L-0.676,4.048C-1.145,4.049 -1.614,4.049 -2.082,4.048L-2.204,4.035L-2.334,3.844C-2.324,3.756 -2.281,3.688 -2.189,3.666L-2.058,3.651C-1.913,3.65 -1.768,3.651 -1.616,3.651L-1.616,1.643C-1.894,1.728 -2.16,1.805 -2.423,1.89C-2.521,1.922 -2.615,1.971 -2.711,2.011C-2.801,2.049 -2.874,2.03 -2.907,1.96C-2.94,1.888 -2.911,1.821 -2.82,1.778C-2.27,1.522 -1.699,1.349 -1.083,1.387C-0.952,1.395 -0.822,1.431 -0.692,1.455L-0.629,1.474C-0.401,1.532 -0.263,1.437 -0.269,1.201C-0.275,0.949 -0.294,0.695 -0.33,0.445C-0.433,-0.275 -0.451,-0.998 -0.429,-1.723C-0.42,-2.005 -0.414,-2.287 -0.407,-2.569L-0.398,-2.663L-0.267,-2.76L-0.151,-2.657L-0.148,-2.562C-0.156,-1.948 -0.178,-1.333 -0.167,-0.719C-0.16,-0.335 -0.103,0.049 -0.067,0.433C-0.055,0.565 -0.036,0.697 -0.019,0.829L0,0.909L0,1.289Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,240.103,116.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.25L0,2.349C0.032,2.19 0.057,2.051 0.089,1.913C0.121,1.771 0.155,1.63 0.199,1.492C0.588,0.258 1.348,-0.636 2.579,-1.095L2.632,-1.224C2.603,-1.456 2.574,-1.688 2.538,-1.919C2.51,-2.101 2.473,-2.283 2.44,-2.464L2.26,-2.44C1.63,-2.34 0.997,-2.288 0.36,-2.298C0.172,-2.3 -0.019,-2.299 -0.178,-2.451L-0.151,-2.301L-1.222,-2.301L-1.21,-2.403L-1.254,-2.355L-1.382,-2.254C-1.682,-2.257 -1.983,-2.256 -2.284,-2.259L-2.404,-2.303L-2.533,-2.257L-2.545,-2.135L0.972,-2.135L0.972,-1.25L0,-1.25ZM2.318,-3.49C2.341,-3.594 2.353,-3.692 2.384,-3.784C2.504,-4.146 2.869,-4.382 3.294,-4.361C3.676,-4.343 3.993,-4.189 4.158,-3.828C4.227,-3.678 4.239,-3.5 4.263,-3.333C4.323,-2.923 4.37,-2.512 4.431,-2.103C4.494,-1.688 4.58,-1.275 4.573,-0.852C4.567,-0.428 4.236,-0.048 3.813,-0.038C3.346,-0.026 2.927,0.111 2.535,0.349C1.978,0.687 1.615,1.181 1.422,1.798C1.353,2.02 1.314,2.252 1.267,2.48C1.173,2.947 0.646,3.132 0.287,2.978C0.146,2.917 0.072,2.833 -0.004,2.641L-0.004,3.002L-3.993,3.002L-3.993,-1.25L-4.525,-1.25L-4.525,-2.135L-2.588,-2.135L-2.57,-2.247L-2.508,-2.333L-2.378,-2.429L-2.335,-2.439L-1.359,-2.439L-1.344,-2.284L-1.298,-2.325C-1.257,-2.44 -1.211,-2.475 -1.087,-2.478C-1.019,-2.48 -0.96,-2.491 -0.944,-2.582L-1.058,-2.517C-0.937,-2.689 -0.547,-2.754 -0.252,-2.527L-0.323,-2.774C-0.369,-3.085 -0.159,-3.33 0.156,-3.335C0.413,-3.339 0.67,-3.321 0.925,-3.341C1.376,-3.375 1.825,-3.43 2.274,-3.477L2.318,-3.49Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00100301,-0.999999,-0.999999,0.00100301,242.827,109.576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.995,-1C-1.539,-1 -1.994,-0.547 -1.994,-0.004C-1.993,0.536 -1.536,0.993 -0.995,0.994C-0.451,0.994 -0,0.542 -0,-0.004C-0.001,-0.553 -0.447,-1 -0.995,-1",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,236.581,111.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.857L0.139,0.849C0.096,0.24 0.054,-0.364 0.012,-0.979C0.156,-0.99 0.29,-1 0.441,-1.011C0.495,-0.245 0.549,0.516 0.603,1.292C0.462,1.302 0.325,1.313 0.176,1.324C0.165,1.193 0.155,1.065 0.144,0.938L0.13,0.938C0.13,1.169 0.127,1.399 0.135,1.63L0.23,1.703C0.333,1.712 0.437,1.706 0.545,1.706L0.545,1.842C0.403,1.844 0.257,1.868 0.12,1.813L0.005,1.68C-0.006,1.409 0,1.137 0,0.857",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,58.9453,107.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.631L-8.501,14.631C-10.194,14.631 -11.566,13.259 -11.566,11.566L-11.566,3.065C-11.566,1.373 -10.194,0 -8.501,0L0,0C1.693,0 3.065,1.373 3.065,3.065L3.065,11.566C3.065,13.259 1.693,14.631 0,14.631",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.5728,114.644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.93L0.534,-2.93L0.534,-2.546L0.614,-2.546C1.231,-2.545 1.848,-2.548 2.466,-2.545C3.645,-2.54 4.574,-1.612 4.581,-0.432C4.585,0.142 4.582,0.715 4.581,1.289L4.581,1.375L4.902,1.375L4.902,1.978L2.145,1.978L2.145,1.379L2.463,1.379L2.468,1.331C2.468,0.89 2.468,0.448 2.469,0.007C2.47,-0.12 2.44,-0.233 2.345,-0.323C2.272,-0.392 2.184,-0.431 2.084,-0.432C1.582,-0.433 1.08,-0.432 0.578,-0.432L0.537,-0.428L0.537,-0.042L0.468,-0.042C-0.049,-0.042 -0.566,-0.043 -1.083,-0.04L-1.15,-0.111C-1.146,-0.215 -1.149,-0.319 -1.149,-0.431L-2.658,-0.431L-2.658,-2.544L-1.152,-2.544L-1.152,-2.929L-0.611,-2.929L-0.611,-4.162L-0.824,-4.162C-1.047,-4.162 -1.271,-4.163 -1.494,-4.162C-1.718,-4.161 -1.89,-4.316 -1.893,-4.525C-1.896,-4.738 -1.734,-4.903 -1.51,-4.904C-0.974,-4.907 -0.438,-4.905 0.098,-4.905C0.365,-4.905 0.632,-4.908 0.899,-4.905C1.145,-4.903 1.318,-4.694 1.272,-4.461C1.237,-4.285 1.089,-4.164 0.901,-4.163C0.632,-4.161 0.363,-4.162 0.094,-4.162L0,-4.162L0,-2.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.0941,119.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.565C0.086,-2.395 0.159,-2.228 0.251,-2.072C0.39,-1.838 0.54,-1.61 0.69,-1.383C0.977,-0.946 0.827,-0.381 0.362,-0.155C0.042,0 -0.344,-0.069 -0.596,-0.327C-0.842,-0.578 -0.905,-0.968 -0.742,-1.278C-0.684,-1.388 -0.611,-1.491 -0.54,-1.594C-0.341,-1.883 -0.169,-2.188 -0.027,-2.509L0,-2.565Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.24699,-0.328539,0.328539,6.24699,145.455,133.536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.231,-4.418C1.836,-2.132 0.133,4.323 0.116,4.387L0.231,4.418C0.303,4.151 1.966,-2.155 0.328,-4.486L0.231,-4.418Z",
    style: {
      fill: "url(#_Linear19)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.55093,0,0,8.55093,148.401,139.732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.456,-2.469C-0.424,-1.76 0.235,2.398 0.263,2.575L0.349,2.561C0.342,2.518 -0.33,-1.724 0.511,-2.402C0.635,-2.502 0.785,-2.515 0.968,-2.443L1,-2.523C0.913,-2.558 0.83,-2.575 0.753,-2.575C0.643,-2.575 0.544,-2.54 0.456,-2.469Z",
    style: {
      fill: "url(#_Linear20)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.63838,-1.57853,1.57853,5.63838,140.241,149.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.486,-1.806C1.161,-0.955 0.372,1.84 0.364,1.868L0.486,1.903C0.52,1.785 1.302,-0.983 0.586,-1.885L0.486,-1.806Z",
    style: {
      fill: "url(#_Linear21)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.914,-1.0218,1.0218,10.914,153.577,141.425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.149,1.781L-0.082,1.781C-0.081,1.756 -0.07,-0.748 1.163,-1.711L1.121,-1.764C-0.138,-0.782 -0.149,1.756 -0.149,1.781Z",
    style: {
      fill: "url(#_Linear22)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.0715,0,0,11.0715,145.534,130.384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.385C-0.001,1.625 0.187,2.758 0.188,2.769L0.255,2.759C0.247,2.713 -0.479,-1.741 1,-2.713L0.963,-2.769C0.325,-2.35 0.001,-1.289 0,0.385Z",
    style: {
      fill: "url(#_Linear23)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,157.761,159.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.638C3.727,17.581 3.56,7.546 3.56,0.004L3.56,0L-17.044,0L-17.044,0.004C-17.044,7.542 -16.732,17.581 -12.846,22.638L0,22.638Z",
    style: {
      fill: "rgb(229,6,126)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,157.765,176.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.784L-3.625,5.784C-3.624,5.783 -3.623,5.781 -3.622,5.78L-0.004,5.78C1.129,4.243 1.902,2.247 2.429,0L2.434,0C1.906,2.248 1.133,4.247 0,5.784",
    style: {
      fill: "rgb(94,92,91)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,160.198,159.308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.854L-0.005,16.854C1.203,11.708 1.122,5.25 1.122,0L1.13,0L1.13,0.004C1.127,5.25 1.208,11.708 0,16.854",
    style: {
      fill: "rgb(193,128,154)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,157.761,159.308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.634L-3.618,22.634C0.106,17.576 -0.061,7.544 -0.061,0.004L-0.061,0L3.56,0C3.56,5.25 3.641,11.708 2.433,16.854C1.906,19.101 1.133,21.097 0,22.634",
    style: {
      fill: "rgb(186,36,110)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,145.614,159.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.952C-1.881,17.927 -2.508,14.308 -3.028,10.838C-3.324,8.855 -3.457,6.838 -3.518,4.837C-3.56,3.242 -3.602,1.591 -3.37,0C-3.207,1.591 -2.918,3.181 -2.701,4.764C-2.439,6.694 -2.226,8.627 -1.941,10.552C-1.679,12.474 -1.421,14.396 -1.09,16.306C-0.821,17.885 -0.444,19.415 0,20.952",
    style: {
      fill: "rgb(238,110,166)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.4929,0,0,15.4929,148.651,105.758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.108,-0.541C0.081,-0.506 0.073,-0.465 0.066,-0.423C0.107,-0.433 0.341,-0.503 0.34,-0.418C0.219,-0.365 0.055,-0.44 0.007,-0.275C-0.004,-0.239 -0.003,-0.207 0.014,-0.173C0.065,-0.209 0.116,-0.247 0.171,-0.276C0.197,-0.289 0.334,-0.326 0.293,-0.256C0.27,-0.215 0.164,-0.195 0.122,-0.174C0.064,-0.144 0.034,-0.123 0.025,-0.055C0.015,0.021 0.017,0.08 0.077,0.133C0.108,0.094 0.335,-0.156 0.381,-0.046C0.404,0.01 0.292,0.043 0.26,0.064C0.214,0.095 0.146,0.132 0.12,0.182C0.084,0.25 0.115,0.319 0.161,0.372C0.201,0.365 0.227,0.26 0.247,0.227C0.273,0.184 0.324,0.14 0.377,0.148C0.377,0.225 0.329,0.26 0.284,0.315C0.247,0.359 0.216,0.441 0.293,0.46C0.309,0.465 0.327,0.465 0.344,0.464C0.364,0.464 0.384,0.464 0.404,0.471C0.434,0.482 0.445,0.507 0.469,0.526C0.524,0.572 0.594,0.528 0.609,0.464C0.626,0.395 0.582,0.311 0.574,0.242C0.639,0.257 0.65,0.317 0.653,0.377C0.655,0.42 0.627,0.519 0.7,0.495C0.766,0.474 0.761,0.405 0.767,0.35C0.774,0.283 0.757,0.25 0.723,0.195C0.693,0.145 0.648,0.109 0.638,0.05C0.707,0.018 0.744,0.115 0.764,0.162C0.788,0.219 0.819,0.266 0.829,0.326C0.89,0.301 0.939,0.273 0.933,0.198C0.927,0.132 0.889,0.079 0.843,0.035C0.8,-0.007 0.713,-0.034 0.687,-0.088C0.641,-0.183 0.793,-0.108 0.82,-0.081C0.874,-0.026 0.918,0.047 0.95,0.117C1.006,0.071 1.017,0.001 0.973,-0.056C0.938,-0.1 0.891,-0.16 0.84,-0.183C0.809,-0.197 0.764,-0.199 0.743,-0.229C0.809,-0.264 0.944,-0.157 0.987,-0.107C1.023,-0.167 0.938,-0.235 0.891,-0.254C0.865,-0.264 0.712,-0.297 0.742,-0.345C0.76,-0.373 0.813,-0.345 0.832,-0.332C0.889,-0.393 0.762,-0.444 0.722,-0.451C0.685,-0.458 0.647,-0.456 0.611,-0.447C0.584,-0.44 0.548,-0.421 0.521,-0.432C0.522,-0.538 0.386,-0.599 0.266,-0.599C0.2,-0.599 0.138,-0.581 0.108,-0.541Z",
    style: {
      fill: "url(#_Linear24)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-14.3968,-8.67407,-8.67407,14.3968,145.568,165.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.626,-0.634C0.659,-0.588 0.609,-0.571 0.574,-0.56C0.533,-0.547 0.506,-0.534 0.481,-0.497C0.509,-0.467 0.653,-0.525 0.692,-0.529C0.76,-0.536 0.839,-0.462 0.842,-0.394C0.752,-0.383 0.614,-0.423 0.547,-0.335C0.582,-0.307 0.623,-0.316 0.664,-0.317C0.732,-0.319 0.842,-0.35 0.894,-0.293C0.937,-0.247 0.973,-0.134 0.954,-0.074C0.883,-0.105 0.808,-0.128 0.731,-0.141C0.691,-0.148 0.536,-0.13 0.631,-0.08C0.687,-0.051 0.761,-0.058 0.82,-0.034C0.935,0.013 1.027,0.103 0.993,0.238C0.918,0.147 0.735,0.076 0.62,0.118C0.64,0.146 0.699,0.167 0.729,0.182C0.794,0.215 0.868,0.238 0.922,0.289C0.956,0.32 0.986,0.334 0.979,0.378C0.974,0.412 0.97,0.458 0.959,0.49C0.903,0.416 0.809,0.297 0.707,0.327C0.759,0.386 0.816,0.439 0.862,0.502C0.886,0.534 0.93,0.562 0.901,0.603C0.874,0.642 0.851,0.61 0.813,0.603C0.827,0.627 0.826,0.658 0.841,0.681C0.835,0.694 0.831,0.702 0.83,0.715C0.807,0.698 0.783,0.686 0.758,0.673C0.724,0.655 0.691,0.637 0.661,0.611C0.611,0.567 0.593,0.537 0.586,0.472C0.581,0.426 0.578,0.344 0.556,0.304C0.519,0.234 0.488,0.328 0.493,0.368C0.5,0.417 0.503,0.474 0.523,0.518C0.45,0.496 0.399,0.447 0.369,0.376C0.348,0.326 0.337,0.255 0.344,0.201C0.349,0.169 0.411,0.06 0.341,0.072C0.286,0.082 0.256,0.193 0.249,0.239C0.238,0.308 0.279,0.368 0.306,0.427C0.259,0.4 0.191,0.352 0.165,0.302C0.143,0.259 0.156,0.196 0.165,0.15C0.176,0.097 0.255,0.014 0.24,-0.037C0.216,-0.115 0.144,-0.014 0.131,0.018C0.108,0.071 0.09,0.126 0.134,0.172C0.045,0.138 0.01,0.04 0.037,-0.045C0.051,-0.088 0.07,-0.123 0.1,-0.155C0.113,-0.169 0.189,-0.237 0.144,-0.244C0.101,-0.251 0.075,-0.164 0.06,-0.139C0.032,-0.092 -0.004,-0.076 0.006,-0.143C0.017,-0.226 -0.018,-0.322 0.013,-0.401C0.033,-0.452 0.091,-0.505 0.139,-0.528C0.184,-0.548 0.227,-0.524 0.274,-0.519C0.309,-0.527 0.333,-0.572 0.358,-0.593C0.403,-0.631 0.544,-0.689 0.608,-0.65C0.615,-0.646 0.621,-0.64 0.626,-0.634ZM0.27,-0.519L0.257,-0.519C0.261,-0.518 0.266,-0.518 0.27,-0.519Z",
    style: {
      fill: "url(#_Linear25)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-22.1021,0,0,22.1021,179.037,152.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.88,-0.342C0.91,-0.33 0.948,-0.282 0.981,-0.283C0.977,-0.3 0.946,-0.326 0.983,-0.327C1.033,-0.328 1.083,-0.283 1.114,-0.248C1.127,-0.235 1.172,-0.187 1.17,-0.16L1.165,-0.162C1.166,-0.16 1.168,-0.159 1.169,-0.157L1.17,-0.159C1.17,-0.158 1.17,-0.158 1.17,-0.157C1.189,-0.137 1.198,-0.11 1.221,-0.093C1.272,-0.055 1.31,-0.032 1.332,0.032C1.344,0.067 1.336,0.088 1.327,0.123C1.319,0.154 1.322,0.184 1.293,0.204C1.291,0.163 1.285,0.127 1.261,0.091C1.248,0.071 1.232,0.053 1.215,0.036C1.195,0.015 1.167,0.006 1.146,-0.013C1.164,0.018 1.178,0.048 1.192,0.08C1.213,0.126 1.273,0.202 1.234,0.252C1.194,0.303 1.099,0.307 1.042,0.322C1.086,0.274 1.09,0.212 1.089,0.149C1.089,0.125 1.053,-0.04 1.011,-0.006C0.986,0.014 1.022,0.121 1.021,0.153C1.018,0.207 1.014,0.284 0.958,0.309C0.906,0.332 0.843,0.345 0.788,0.357C0.793,0.294 0.806,0.224 0.827,0.164C0.839,0.129 0.863,0.098 0.873,0.062C0.879,0.041 0.876,0.025 0.852,0.038C0.811,0.06 0.805,0.137 0.791,0.177C0.775,0.223 0.772,0.295 0.729,0.326C0.701,0.347 0.659,0.341 0.62,0.336C0.6,0.333 0.582,0.33 0.566,0.331C0.581,0.303 0.608,0.278 0.625,0.252C0.64,0.229 0.693,0.16 0.68,0.133C0.672,0.136 0.665,0.14 0.657,0.143C0.594,0.176 0.554,0.242 0.503,0.287C0.473,0.314 0.454,0.283 0.434,0.261C0.412,0.237 0.384,0.222 0.369,0.192C0.36,0.173 0.332,0.117 0.339,0.097C0.35,0.069 0.415,0.072 0.439,0.065C0.495,0.048 0.551,0.047 0.606,0.033C0.661,0.02 0.614,-0.016 0.581,-0.02C0.495,-0.03 0.415,-0 0.338,0.031C0.338,0.001 0.358,-0.034 0.371,-0.062C0.394,-0.115 0.514,-0.109 0.565,-0.115C0.597,-0.118 0.629,-0.115 0.661,-0.112C0.7,-0.109 0.738,-0.105 0.776,-0.113C0.784,-0.146 0.735,-0.15 0.713,-0.153C0.661,-0.162 0.612,-0.151 0.56,-0.149C0.528,-0.147 0.497,-0.147 0.465,-0.141C0.441,-0.137 0.412,-0.127 0.388,-0.13C0.395,-0.164 0.42,-0.205 0.445,-0.228C0.502,-0.28 0.58,-0.265 0.648,-0.251C0.69,-0.242 0.733,-0.234 0.775,-0.223C0.81,-0.214 0.842,-0.195 0.879,-0.203C0.875,-0.223 0.846,-0.232 0.829,-0.239C0.746,-0.27 0.651,-0.286 0.562,-0.285C0.583,-0.3 0.592,-0.32 0.62,-0.328C0.666,-0.342 0.726,-0.331 0.767,-0.308C0.823,-0.276 0.873,-0.249 0.939,-0.25C0.92,-0.311 0.819,-0.312 0.779,-0.349C0.791,-0.354 0.804,-0.357 0.817,-0.357C0.838,-0.357 0.86,-0.35 0.88,-0.342ZM1.17,-0.16L1.17,-0.159C1.17,-0.159 1.17,-0.16 1.17,-0.16L1.17,-0.16Z",
    style: {
      fill: "url(#_Linear26)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.86081,19.4836,-19.4836,5.86081,150.556,139.606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.392,-0.094C-0.381,-0.071 -0.37,-0.053 -0.377,-0.031C-0.41,-0 -0.456,0.025 -0.476,0.066C-0.497,0.111 -0.507,0.169 -0.494,0.217C-0.49,0.234 -0.487,0.264 -0.475,0.278C-0.453,0.306 -0.448,0.278 -0.449,0.258C-0.451,0.226 -0.435,0.228 -0.423,0.255C-0.412,0.282 -0.41,0.308 -0.395,0.334C-0.381,0.356 -0.363,0.374 -0.347,0.394C-0.333,0.412 -0.321,0.443 -0.292,0.432C-0.275,0.467 -0.249,0.493 -0.213,0.508C-0.193,0.516 -0.106,0.54 -0.092,0.512C-0.081,0.492 -0.162,0.427 -0.174,0.41C-0.201,0.373 -0.227,0.333 -0.245,0.292C-0.263,0.251 -0.274,0.201 -0.264,0.158C-0.261,0.144 -0.253,0.115 -0.234,0.117C-0.213,0.119 -0.208,0.158 -0.205,0.173C-0.19,0.242 -0.171,0.297 -0.136,0.358C-0.112,0.398 -0.097,0.445 -0.061,0.476C0.011,0.54 0.123,0.518 0.208,0.493C0.219,0.489 0.229,0.486 0.239,0.482C0.187,0.448 0.126,0.431 0.078,0.392C0.035,0.358 -0.015,0.31 -0.039,0.261C-0.058,0.221 -0.077,0.164 -0.079,0.12C-0.08,0.102 -0.078,0.065 -0.058,0.056C-0.035,0.044 -0.023,0.077 -0.015,0.093C0.003,0.13 0.019,0.168 0.044,0.201C0.065,0.23 0.092,0.254 0.116,0.281C0.154,0.324 0.186,0.361 0.233,0.393C0.271,0.419 0.301,0.448 0.349,0.447C0.384,0.447 0.458,0.438 0.43,0.387C0.414,0.356 0.379,0.333 0.353,0.31C0.323,0.284 0.298,0.256 0.274,0.224C0.253,0.197 0.232,0.172 0.21,0.147C0.197,0.133 0.168,0.108 0.177,0.086C0.203,0.018 0.315,0.164 0.328,0.181C0.368,0.23 0.426,0.258 0.465,0.307C0.5,0.352 0.532,0.36 0.569,0.308C0.599,0.267 0.62,0.213 0.633,0.164C0.648,0.109 0.67,-0.04 0.586,-0.055C0.535,-0.065 0.485,-0.028 0.431,-0.038C0.407,-0.042 0.386,-0.046 0.362,-0.045C0.344,-0.045 0.301,-0.036 0.286,-0.051C0.25,-0.088 0.404,-0.138 0.425,-0.145C0.475,-0.161 0.517,-0.172 0.569,-0.156C0.588,-0.151 0.606,-0.143 0.625,-0.136C0.59,-0.191 0.574,-0.254 0.497,-0.252C0.425,-0.249 0.35,-0.242 0.285,-0.212C0.248,-0.196 0.149,-0.114 0.108,-0.143C0.047,-0.185 0.223,-0.259 0.244,-0.27C0.281,-0.289 0.316,-0.31 0.357,-0.317C0.391,-0.323 0.426,-0.32 0.46,-0.325C0.467,-0.326 0.475,-0.328 0.482,-0.329C0.443,-0.353 0.402,-0.371 0.361,-0.391C0.324,-0.409 0.284,-0.446 0.241,-0.447C0.192,-0.448 0.148,-0.404 0.106,-0.384C0.058,-0.361 0.023,-0.329 -0.011,-0.29C-0.045,-0.25 -0.07,-0.204 -0.108,-0.167C-0.102,-0.235 -0.083,-0.286 -0.043,-0.341C-0,-0.398 0.053,-0.43 0.108,-0.473C0.168,-0.52 0.11,-0.554 0.055,-0.552C-0.013,-0.549 -0.065,-0.499 -0.105,-0.45C-0.151,-0.394 -0.18,-0.33 -0.21,-0.266C-0.199,-0.348 -0.155,-0.411 -0.108,-0.477C-0.097,-0.493 -0.077,-0.512 -0.072,-0.529C-0.175,-0.543 -0.233,-0.413 -0.265,-0.337C-0.274,-0.317 -0.278,-0.281 -0.303,-0.274C-0.316,-0.306 -0.279,-0.357 -0.261,-0.38C-0.329,-0.396 -0.36,-0.322 -0.382,-0.27C-0.388,-0.257 -0.393,-0.244 -0.397,-0.23C-0.41,-0.185 -0.413,-0.139 -0.392,-0.094ZM-0.384,-0.019L-0.381,-0.027L-0.378,-0.031C-0.379,-0.027 -0.381,-0.023 -0.384,-0.019Z",
    style: {
      fill: "url(#_Linear27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.82444,9.63911,-9.63911,7.82444,130.864,123.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.017,-0.742C-0.048,-0.692 -0.001,-0.7 0.029,-0.713C0.078,-0.734 0.084,-0.707 0.047,-0.674C0.012,-0.643 -0.027,-0.625 -0.058,-0.587C-0.085,-0.553 -0.102,-0.516 -0.125,-0.48C-0.144,-0.448 -0.185,-0.412 -0.152,-0.374C-0.196,-0.329 -0.222,-0.274 -0.225,-0.21C-0.226,-0.175 -0.214,-0.029 -0.164,-0.022C-0.126,-0.017 -0.071,-0.177 -0.052,-0.206C-0.011,-0.266 0.037,-0.33 0.09,-0.38C0.143,-0.43 0.214,-0.475 0.287,-0.485C0.309,-0.487 0.359,-0.491 0.366,-0.461C0.375,-0.428 0.317,-0.398 0.296,-0.385C0.198,-0.323 0.124,-0.264 0.05,-0.175C0.001,-0.117 -0.063,-0.067 -0.092,0.005C-0.15,0.152 -0.054,0.313 0.034,0.429C0.045,0.443 0.056,0.457 0.068,0.471C0.09,0.372 0.083,0.269 0.116,0.173C0.146,0.089 0.191,-0.015 0.253,-0.08C0.303,-0.131 0.381,-0.192 0.448,-0.219C0.475,-0.23 0.533,-0.247 0.558,-0.223C0.589,-0.194 0.545,-0.156 0.525,-0.135C0.478,-0.086 0.429,-0.041 0.391,0.015C0.359,0.064 0.336,0.119 0.308,0.17C0.263,0.253 0.224,0.322 0.201,0.414C0.183,0.485 0.154,0.549 0.182,0.621C0.202,0.675 0.257,0.784 0.32,0.714C0.358,0.671 0.374,0.604 0.395,0.552C0.42,0.492 0.449,0.436 0.484,0.382C0.515,0.336 0.542,0.289 0.568,0.24C0.582,0.214 0.605,0.155 0.643,0.156C0.762,0.158 0.6,0.412 0.582,0.442C0.527,0.531 0.517,0.635 0.463,0.722C0.413,0.803 0.419,0.856 0.519,0.884C0.599,0.907 0.694,0.91 0.776,0.902C0.87,0.894 1.112,0.846 1.089,0.708C1.075,0.624 0.991,0.567 0.975,0.478C0.969,0.44 0.963,0.405 0.949,0.369C0.938,0.341 0.899,0.28 0.914,0.248C0.951,0.172 1.115,0.382 1.138,0.411C1.191,0.478 1.23,0.537 1.235,0.625C1.237,0.658 1.236,0.691 1.235,0.723C1.247,0.707 1.26,0.692 1.274,0.677C1.329,0.614 1.38,0.556 1.342,0.461C1.298,0.352 1.245,0.242 1.163,0.156C1.118,0.109 0.936,0.001 0.957,-0.076C0.989,-0.194 1.201,0.035 1.23,0.062C1.278,0.108 1.331,0.151 1.365,0.21C1.393,0.259 1.408,0.314 1.435,0.364C1.441,0.374 1.447,0.385 1.453,0.395C1.469,0.322 1.473,0.249 1.481,0.175C1.489,0.107 1.523,0.026 1.501,-0.041C1.475,-0.117 1.383,-0.161 1.328,-0.214C1.266,-0.275 1.198,-0.311 1.117,-0.342C1.037,-0.373 0.953,-0.386 0.875,-0.423C0.982,-0.452 1.072,-0.451 1.178,-0.419C1.291,-0.385 1.37,-0.322 1.467,-0.26C1.572,-0.194 1.592,-0.302 1.558,-0.386C1.517,-0.489 1.41,-0.54 1.311,-0.575C1.201,-0.615 1.086,-0.624 0.97,-0.634C1.102,-0.664 1.225,-0.63 1.353,-0.594C1.383,-0.586 1.424,-0.566 1.453,-0.567C1.417,-0.734 1.183,-0.751 1.049,-0.759C1.014,-0.761 0.955,-0.748 0.931,-0.782C0.972,-0.82 1.072,-0.791 1.118,-0.776C1.105,-0.89 0.974,-0.897 0.881,-0.902C0.78,-0.909 0.678,-0.895 0.603,-0.819C0.575,-0.791 0.554,-0.764 0.517,-0.763C0.45,-0.795 0.386,-0.853 0.31,-0.86C0.229,-0.868 0.134,-0.852 0.067,-0.806C0.045,-0.791 0.006,-0.771 -0.013,-0.748C-0.014,-0.746 -0.016,-0.744 -0.017,-0.742ZM0.493,-0.765L0.506,-0.766L0.516,-0.762C0.509,-0.762 0.501,-0.763 0.493,-0.765Z",
    style: {
      fill: "url(#_Linear28)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(17.3701,-4.49458,4.49458,17.3701,154.236,128.995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.358,-0.606C0.333,-0.584 0.307,-0.537 0.272,-0.531C0.226,-0.537 0.183,-0.56 0.139,-0.539C0.091,-0.517 0.033,-0.463 0.013,-0.413C-0.018,-0.334 0.017,-0.237 0.006,-0.155C-0.004,-0.088 0.032,-0.104 0.06,-0.151C0.075,-0.176 0.101,-0.263 0.144,-0.256C0.189,-0.248 0.113,-0.181 0.1,-0.167C0.07,-0.135 0.051,-0.099 0.037,-0.057C0.01,0.028 0.045,0.126 0.134,0.16C0.09,0.114 0.108,0.059 0.131,0.006C0.144,-0.026 0.216,-0.127 0.24,-0.049C0.255,0.003 0.176,0.086 0.165,0.138C0.156,0.185 0.143,0.247 0.165,0.291C0.191,0.34 0.259,0.389 0.307,0.416C0.279,0.356 0.238,0.296 0.249,0.227C0.256,0.181 0.286,0.07 0.341,0.061C0.411,0.049 0.349,0.157 0.345,0.189C0.337,0.243 0.348,0.315 0.37,0.365C0.399,0.435 0.45,0.484 0.523,0.507C0.503,0.462 0.501,0.405 0.494,0.357C0.488,0.316 0.519,0.223 0.557,0.292C0.578,0.333 0.581,0.414 0.586,0.461C0.594,0.526 0.611,0.556 0.661,0.6C0.712,0.645 0.775,0.665 0.83,0.704C0.831,0.692 0.835,0.684 0.841,0.671C0.827,0.647 0.828,0.616 0.813,0.592C0.824,0.594 0.834,0.598 0.842,0.602C0.865,0.611 0.882,0.619 0.901,0.592C0.93,0.551 0.886,0.523 0.862,0.491C0.816,0.428 0.76,0.375 0.707,0.316C0.81,0.286 0.903,0.405 0.958,0.479C0.969,0.447 0.974,0.401 0.979,0.367C0.986,0.323 0.956,0.309 0.922,0.277C0.868,0.226 0.794,0.203 0.73,0.171C0.699,0.156 0.64,0.134 0.62,0.107C0.735,0.064 0.918,0.135 0.993,0.227C1.027,0.091 0.935,0.002 0.82,-0.046C0.792,-0.057 0.762,-0.061 0.732,-0.066C0.696,-0.071 0.661,-0.076 0.631,-0.091C0.536,-0.142 0.691,-0.159 0.731,-0.153C0.807,-0.139 0.883,-0.116 0.954,-0.085C0.973,-0.146 0.936,-0.258 0.894,-0.305C0.842,-0.362 0.732,-0.331 0.664,-0.329C0.623,-0.328 0.581,-0.319 0.547,-0.347C0.614,-0.435 0.752,-0.395 0.842,-0.406C0.839,-0.474 0.76,-0.548 0.691,-0.541C0.653,-0.537 0.509,-0.479 0.481,-0.509C0.506,-0.547 0.533,-0.559 0.574,-0.572C0.609,-0.583 0.659,-0.6 0.626,-0.646C0.616,-0.659 0.603,-0.667 0.586,-0.671C0.516,-0.69 0.398,-0.64 0.358,-0.606ZM0.286,-0.53C0.285,-0.53 0.285,-0.53 0.284,-0.53L0.286,-0.53ZM0.268,-0.531C0.265,-0.53 0.261,-0.531 0.257,-0.531L0.268,-0.531Z",
    style: {
      fill: "url(#_Linear29)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.4713,0,0,19.4713,130.634,108.494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.441,-0.349C0.481,-0.312 0.582,-0.311 0.601,-0.25C0.535,-0.249 0.485,-0.276 0.429,-0.308C0.388,-0.331 0.328,-0.342 0.282,-0.328C0.254,-0.32 0.245,-0.301 0.224,-0.285C0.313,-0.287 0.408,-0.27 0.491,-0.239C0.508,-0.233 0.538,-0.223 0.542,-0.203C0.504,-0.196 0.472,-0.214 0.437,-0.223C0.395,-0.234 0.353,-0.242 0.31,-0.251C0.242,-0.265 0.165,-0.28 0.108,-0.228C0.082,-0.205 0.057,-0.164 0.05,-0.13C0.074,-0.127 0.103,-0.137 0.127,-0.141C0.16,-0.147 0.19,-0.147 0.223,-0.149C0.274,-0.151 0.323,-0.162 0.375,-0.153C0.397,-0.15 0.446,-0.146 0.438,-0.113C0.4,-0.105 0.362,-0.109 0.323,-0.112C0.291,-0.115 0.259,-0.118 0.227,-0.115C0.176,-0.11 0.056,-0.115 0.033,-0.062C0.021,-0.034 0,0.001 0,0.032C0.078,-0 0.157,-0.03 0.243,-0.02C0.276,-0.016 0.323,0.02 0.268,0.034C0.213,0.047 0.157,0.049 0.101,0.065C0.077,0.072 0.012,0.069 0.001,0.097C-0.007,0.118 0.022,0.173 0.031,0.192C0.046,0.222 0.074,0.237 0.096,0.261C0.116,0.283 0.135,0.314 0.164,0.288C0.216,0.242 0.256,0.176 0.319,0.143C0.326,0.14 0.334,0.136 0.341,0.133C0.355,0.16 0.302,0.229 0.287,0.252C0.27,0.278 0.243,0.303 0.228,0.331C0.244,0.33 0.262,0.333 0.281,0.336C0.321,0.341 0.363,0.347 0.391,0.326C0.434,0.295 0.437,0.223 0.453,0.177C0.467,0.137 0.473,0.061 0.514,0.038C0.538,0.025 0.541,0.041 0.535,0.062C0.525,0.098 0.501,0.13 0.489,0.165C0.468,0.224 0.455,0.294 0.45,0.357C0.505,0.345 0.568,0.332 0.62,0.309C0.676,0.284 0.68,0.207 0.683,0.153C0.684,0.121 0.648,0.014 0.674,-0.006C0.715,-0.039 0.751,0.125 0.751,0.149C0.752,0.212 0.748,0.274 0.704,0.322C0.762,0.307 0.856,0.303 0.896,0.252C0.935,0.202 0.875,0.126 0.854,0.08C0.84,0.048 0.826,0.018 0.808,-0.012C0.829,0.006 0.857,0.015 0.877,0.036C0.893,0.054 0.91,0.072 0.923,0.091C0.947,0.127 0.953,0.163 0.955,0.204C0.984,0.184 0.981,0.154 0.989,0.123C0.998,0.089 1.006,0.067 0.994,0.032C0.972,-0.032 0.934,-0.055 0.883,-0.093C0.86,-0.11 0.85,-0.137 0.832,-0.157C0.832,-0.157 0.832,-0.158 0.832,-0.159L0.831,-0.157C0.83,-0.159 0.828,-0.16 0.827,-0.161L0.832,-0.16C0.834,-0.187 0.788,-0.235 0.776,-0.249C0.745,-0.283 0.695,-0.328 0.645,-0.327C0.608,-0.326 0.639,-0.301 0.643,-0.283C0.609,-0.282 0.572,-0.33 0.542,-0.342C0.522,-0.35 0.5,-0.357 0.478,-0.357C0.466,-0.357 0.453,-0.354 0.441,-0.349ZM0.832,-0.159L0.832,-0.16L0.832,-0.16C0.832,-0.159 0.832,-0.159 0.832,-0.159Z",
    style: {
      fill: "url(#_Linear30)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image6",
    width: "45px",
    height: "44px",
    xlinkHref: "data:image/png;base64,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"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "1px",
    height: "4px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAECAYAAABP2FU6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAE0lEQVQImWNw8fD9z8TAwMCAIAAfeQHfm1PJCAAAAABJRU5ErkJggg=="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image12",
    width: "46px",
    height: "44px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAsCAYAAAAacYo8AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABg0lEQVRYhe2YwW6DMBBEZ1H+LyokgappDpXyX700Fa2owgeym0MFqYPX0DSK11JH4gJCfh7P2ivTclkIbiyi8Tu58SgLAGjbxjOUTfVGZ7FBrlUGnGeRitq2obQdT1FZioUJpOx4bIDfqk/IAJ7azpKc473SBk9hZ8nztRPls+O+zsiQMnINHsCJgKJYmy3Q7MLYMzho9NGSSAPP6PuxKiI3DAN48/VpFntXlUJQHAcAq+REwPtH7eC54ETYVaXZAv2pC/BYGGH5uNI+OS1rv6280XXAD3VtLixawZl3HABeD2NDveAvT/7liaHZjgtuf+v0JyksI3AWgI2Q758rYYV8BP5W12SEGyz66nszboQbIv7CBBRwFpg4+kOR9YJ3LCZc5wCEGpXOADmz/k2NCoemewdtq1KuMm+92kQlf9yEx1ePfGbBJiL81IIv9B8l6r44FVUdPHLGu4nxg91hLPj8YSVTbYfJtpZFcDyGrwVV8P66K8b185xeyaTjc/QPfm+dAA21j2T68kVdAAAAAElFTkSuQmCC"
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image15",
    width: "7px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAUElEQVQImV2OMQ6AMAwD71CfyczM/1VqhhRBiZQhsS+x57FHQd7K7NYjBnCVE2h9iAaTHyntSjBlYC6BIq8Bks/TMo06W4NLpCfQgO1DvKLcnsInKSRy/YgAAAAASUVORK5CYII="
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image18",
    width: "8px",
    height: "8px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAS0lEQVQYlX2NMQ6EQAzEnDwRhK6g4P9v2GTmCkoIbm3Jcf02R0DwxA44j90vDrhd9qihZHJ9FCXI0hy0TJbmxWqT3XOxJFKeFzb8AYA/J84Bf3VFAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear19",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.99862,0.052519,0.052519,-0.99862,0.00127501,-0.0485206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,1.18116e-05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.962974,0.269596,0.269596,-0.962974,0.0186391,-0.135715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.995646,0.0932152,0.0932152,-0.995646,0.00172451,-0.0369201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear23",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,5.07611e-06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.026926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear25",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,5.55112e-17,5.55112e-17,-1,0,0.0257753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-2.76173e-05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.0133708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear28",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-5.55112e-17,-5.55112e-17,-1,0,0.00116891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-2.77556e-17,-2.77556e-17,-1,0,0.0142614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,3.30743e-06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(85,129,84)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(120,154,117)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseImage);
export default __webpack_public_path__ + "static/media/HouseImage.d1eee0e833b96eeb6458be82e07d25fe.svg";
export { ForwardRef as ReactComponent };